import React from "react";
import classNames from "classnames";
import {Alert, Button, ButtonGroup} from 'reactstrap';
import {InputAdornment, TextField, Card, CardContent} from "@material-ui/core";
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Cards from 'react-credit-cards';
import Cookies from 'js-cookie';
import ClipLoader from 'react-spinners/ClipLoader';
import Typography from '@material-ui/core/Typography';
import moment from "moment";
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import 'react-credit-cards/es/styles-compiled.css';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {Link} from "react-router-dom";
import {confirmAlert} from "react-confirm-alert";
import APPCONFIG from "../../constants/Config";
import {Collections, Objects} from "../index";
import {isNumeric} from "echarts/lib/util/number";
import CustomerComponent from "./Parts/CustomerComponent"
import CheckoutAddItemSelect from "../Parts/CheckoutAddItemSelect";
import MembershipBillingAlert from "components/Elements/MembershipBillingAlert";
const { UniversalModal } = Framework.Elements;
import {cashDiscount} from "../../constants/Utilities";
import {shouldApplyCashDiscount} from "../../utils/cashDiscountPaymentTypes";
import {checkoutHasLines, countCheckoutLines, checkoutPaymentFillAmount, checkoutPaymentsBalanced, checkoutBalanceDisplay, checkoutMaxInvoiceAmount, checkoutInvoiceAllowed, isUnsetPaymentAmount, checkoutPaymentFieldAmount, formatCheckoutPaymentAmount, checkoutIsContractPayment, TOLERANCE} from "../../utils/checkoutLines";
import {getPreferredRegister, isRegisterUnset, persistRegisterSelection} from "../../utils/preferredRegister";
import {membershipDateSummary, membershipRole} from "../../utils/membershipCoveredMembers";
import {membershipDiscountForLine, membershipDiscountsInPriorityOrder} from "../../utils/membershipDiscounts";
import {toast} from "react-toastify";
import {catalogTaxable} from "../../utils/catalogTaxable";
import {
	applyCheckoutCcFee,
	checkoutCcFeePercent,
	checkoutShouldApplyCcFee,
	isApplyCcFeeToDebitEnabled,
	isAutoCcFeeEnabled,
	showManualCcFeeButton,
} from "../../utils/ccFee";

const CHECKOUT_LINE_TYPES = {
	Items: Types.Checkouts_Items._name,
	Consignments: Types.Checkouts_Consignments._name,
	Products: Types.Checkouts_Products._name,
	Services: Types.Checkouts_Services._name,
};

const getKioskSelectProperty = () => ({
	class: Types.Kiosks._name,
	type: "fkey",
	name: "shared_kiosk",
	label: "Share to Kiosk",
});

function newCheckoutLocationCombinedRate(location) {
	if (!location) return 0;
	return (
		parseFloat(location.tax_rate_city || 0) +
		parseFloat(location.tax_rate_county || 0) +
		parseFloat(location.tax_rate_special || 0) +
		parseFloat(location.tax_rate_state || 0)
	);
}

function newCheckoutInventoryFromItem(item) {
	if (!item) return null;
	// Propel TYPE_PHPNAME uses PascalCase; camel/fieldname use lowercase
	return item.inventories ?? item.Inventories ?? null;
}

function newCheckoutSkuFromInventory(inv) {
	if (!inv) return null;
	return inv.skus ?? inv.Skus ?? null;
}

function newCheckoutSkuClassFromSku(sku) {
	if (!sku) return null;
	return sku.sku_classes ?? sku.skuClasses ?? sku.SkuClasses ?? null;
}

function newCheckoutSkuClassFromItem(item) {
	return newCheckoutSkuClassFromSku(newCheckoutSkuFromInventory(newCheckoutInventoryFromItem(item)));
}

function newCheckoutCoerceBool(v) {
	if (v === true || v === 1 || v === '1' || v === 'true') return true;
	if (v === false || v === 0 || v === '0' || v === 'false') return false;
	return !!v;
}

function newCheckoutNumericTaxOverride(sc) {
	if (!sc || sc.tax_override == null) return null;
	const raw = sc.tax_override;
	const n = typeof raw === 'object' && raw !== null && 'value' in raw
		? parseFloat(raw.value)
		: parseFloat(String(raw).replace(/,/g, ''));
	return Number.isFinite(n) ? n : null;
}

function newCheckoutEffectiveRateForItem(item, location) {
	const combined = newCheckoutLocationCombinedRate(location);
	const sc = newCheckoutSkuClassFromItem(item);
	const overrideNum = newCheckoutNumericTaxOverride(sc);
	if (sc && newCheckoutCoerceBool(sc.should_override) && overrideNum !== null) {
		return overrideNum;
	}
	return combined;
}

function newCheckoutItemTaxGroupName(item) {
	const sc = newCheckoutSkuClassFromItem(item);
	return (sc && sc.name) ? sc.name : 'Default';
}

function newCheckoutSkuClassPkeyFromItem(item) {
	const sc = newCheckoutSkuClassFromItem(item);
	if (!sc) return null;
	const pkey = parseInt(sc.pkey ?? sc.Pkey ?? 0, 10);
	return Number.isFinite(pkey) && pkey > 0 ? pkey : null;
}

function newCheckoutMoney(value) {
	const amount = parseFloat(value || 0);
	return Number.isFinite(amount) ? amount : 0;
}

function newCheckoutFormatMembershipDate(value) {
	if (!value) {
		return "Not set";
	}
	const date = moment(value);
	return date.isValid() ? date.format("MM/DD/YYYY") : "Not set";
}

function newCheckoutMembershipStatus(membership) {
	return membership && membership.display_status ? membership.display_status : "Active";
}

function newCheckoutMembershipDiscountForItem(item, unitCost, quantity, lineDiscount, discounts) {
	return membershipDiscountForLine(
		discounts,
		newCheckoutSkuClassPkeyFromItem(item),
		unitCost,
		quantity,
		lineDiscount,
	);
}

function newCheckoutEffectiveRateForProduct(location, fflLinked) {
	const combined = newCheckoutLocationCombinedRate(location);
	if (!fflLinked || !location) {
		return combined;
	}
	const raw = location.tax_rate_fflboss;
	if (raw == null || String(raw).trim() === '') {
		return combined;
	}
	const r = parseFloat(raw);
	if (!Number.isFinite(r) || r <= 0) {
		return combined;
	}
	return r;
}

function newCheckoutTaxSummaryAppend(map, group, rate, amount, quantity, lineTaxRaw) {
	const g = String(group || 'Default');
	const r = Number.parseFloat(Number(rate).toFixed(4));
	const key = g + '|' + r.toFixed(4);
	if (!map[key]) {
		map[key] = { group: g, rate: r, amount: 0, quantity: 0, tax_raw: 0 };
	}
	map[key].amount += amount;
	map[key].quantity += quantity;
	if (Number.isFinite(lineTaxRaw)) {
		map[key].tax_raw += lineTaxRaw;
	}
}

class CheckoutObject extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Checkouts._name);
		this.read = 'GET_ACTIVE';
		this.state.totals = {
			sub_total_tax: 0,
			sub_total_nontax: 0,
			subtotal: "0.00",
			tax_amount: 0,
			tradein_total: 0,
			membership_discount_amount: 0,
			cash_discount_amount: 0,
			card_fee: 0,
			amount: "0.00",
			remaining: "0.00"
		};
		this.state.sub_total_tax = 0;
		this.state.sub_total_nontax = 0;
		this.state.locations = null;
		this.state.items = [];
		this.state.layaways = [];
		this.state.work_orders = [];
		this.state.products = [];
		this.state.services = [];
		this.state.terminals = [];
		this.state.all_registers = [];
		this.state.manual = false;
		this.state.manual_card = false;
		this.state.optionalFields = false;
		this.state.card_percentage = false;
		this.state.card_expiry = "";
		this.state.sudo_card = "";

		this.state.focused = "";
		this.state.alignment = 'amount';
		this.state.taxable = true;
		this.state.showRegister = false;
		this.state.showOtherFields = false;
		this.state.itemsCount = 0;
		this.state.itemKey = Math.random();
		this.itemRef = React.createRef();
		this.state.itemToChange = {name: '', serial: '', sku: '', cost: 0.00};
		this.state.itemIsChanging = false;
		this.timeout = null;
		this.state.type = null;
		this.state.hasTaxableStatusChanged = false;
		this.state.showAlert = false;
		this.afterCustomerSave = this.setNewObject('customer');

		//layaway state vars
		this.state.layaway = false;
		this.state.work_order = false;
		this.state.product_information = [];

		//conditional payment fields
		this.state.showCashField = false;
		this.state.showCheckField = false;
		this.state.showZelleField = false;
		this.state.showGiftCertField = false;
		this.state.showInvoiceField = false;
		this.state.showCreditCardButtons = false;
		this.state.showDebitCardButtons = false;
		this.state.card_charge = false;
		this.state.zelle_amount = this.state.zelle_amount || "0.00";
		this.state.is_debit = false;

		//multiple gift certs
		this.state.gift_certificates = [];
		this.state.allCertificates = [];
		this.state.sharedKiosk = null;
		this.state.shared_kiosk_error = "";
		this.state.hasKiosks = false;

		this.pause = this.pause.bind(this)
		this.checkout = this.checkout.bind(this);

		this.terminalRequest = {};
		this.state.membership_inventory_group_discounts = [];
		this.state.customer_memberships = [];
		this.state.membershipDiscountCustomer = null;
		this.state.customerMembershipsLoading = false;
		this.membershipDiscountCustomerPkey = null;
		this.customerMembershipCustomerPkey = null;
		this.clientSaveTimeout = null;
		this._ccFeeRootSub = null;
		if (props.rootState && typeof props.rootState.subscribe === 'function') {
			this._ccFeeRootSub = props.rootState.subscribe({
				auto_cc_fee: () => this.forceUpdate(),
				apply_cc_fee_to_debit: () => this.forceUpdate(),
				location: () => this.forceUpdate(),
			});
		}
		const afterCustomerSave = this.afterCustomerSave;
		this.afterCustomerSave = (data) => {
			afterCustomerSave(data);
			void this.loadCustomerMembershipDiscounts(data?.pkey ?? this.state.customer);
			void this.loadCustomerMemberships(data?.pkey ?? this.state.customer);
		};

		const frameworkSelectPropertyUpdate = this.handleSelectPropertyUpdate;
		this.handleSelectPropertyUpdate = (property, value, linked, object) => {
			frameworkSelectPropertyUpdate(property, value, linked, object);
			persistRegisterSelection(property, value);
		};

	}

	ccFeeFlags = () => ({
		auto_cc_fee: this.props.auto_cc_fee || this.props.rootState?.auto_cc_fee,
		apply_cc_fee_to_debit: this.props.apply_cc_fee_to_debit != null
			? this.props.apply_cc_fee_to_debit
			: this.props.rootState?.apply_cc_fee_to_debit,
		location: this.props.posLocation || this.props.rootState?.location,
		rootState: this.props.rootState,
	});

	applyPreferredRegisterIfNeeded = () => {
		if (!this.state.loaded || !isRegisterUnset(this.state.register)) {
			return;
		}
		const preferred = getPreferredRegister();
		if (preferred != null) {
			this.setState({register: preferred});
		}
	};

	loadSelfBefore = async (data) => {
		if (data && data.invoice_amount != null) {
			data.invoice_amount = formatCheckoutPaymentAmount(data.invoice_amount);
		}
		if (data && data.zelle_amount != null) {
			data.zelle_amount = formatCheckoutPaymentAmount(data.zelle_amount);
		}
		if (data) {
			// checkouts.is_debit is kiosk apply-fee, not debit tender.
			data.is_debit = false;
		}
		return data;
	};

	refreshCheckoutItems = async () => {
		await Promise.all([
			this.loadItems(),
			this.loadConsignments(),
			this.loadServices(),
			this.loadProducts(),
			this.loadTrades(),
			this.loadLayaways(),
			this.loadWorkOrders()
		]);
		this.syncSessionItemsCount();
	}

	syncSessionItemsCount = () => {
		if (!this.props.rootState) {
			return;
		}
		this.props.rootState.set({
			session_items_count: countCheckoutLines(this.state),
		});
	}

	handleCheckoutAddItemAdded = async (type) => {
		if (!this.state.pkey) {
			await this.loadSelf();
		}

		switch (type) {
			case 'inventory':
				await this.loadItems();
				break;
			case 'service':
				await this.loadServices();
				break;
			case 'product':
				await this.loadProducts();
				break;
			case 'consignment':
				await this.loadConsignments();
				break;
			default:
				await this.refreshCheckoutItems();
				break;
		}
		this.syncSessionItemsCount();
	}

	componentDidMount() {
		if (super.componentDidMount) {
			super.componentDidMount();
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (prevProps.shouldReloadCart !== this.props.shouldReloadCart) {
			void this.refreshCheckoutItems();
		}

		if (this.props.scannedCode
			&& this.props.scannedCode !== prevProps.scannedCode
			&& this.props.scannedCode.type === 'customer') {
			this.applyScannedCustomer(this.props.scannedCode);
		}

		if (this.props.scannedCode
			&& this.props.scannedCode !== prevProps.scannedCode
			&& this.props.scannedCode.type === 'GC') {
			this.handleScannedGiftCertificate(this.props.scannedCode.id);
		}

		if (this.state.loaded && !prevState.loaded) {
			void this.loadKioskSharing();
			void this.persistCcFeeForKiosk();
		}

		const ccFlags = this.ccFeeFlags();
		const autoCcFee = isAutoCcFeeEnabled(ccFlags);
		const debitTakesCcFee = isApplyCcFeeToDebitEnabled(ccFlags);
		const processorTenderOpen = this.state.showCreditCardButtons
			|| (this.state.showDebitCardButtons && debitTakesCcFee);
		if (autoCcFee && processorTenderOpen && !this.state.card_percentage) {
			this.setState({card_percentage: true}, () => {
				void this.persistCcFeeForKiosk();
			});
		} else if (
			(
				!!prevProps.auto_cc_fee !== !!this.props.auto_cc_fee
				|| !!prevProps.apply_cc_fee_to_debit !== !!this.props.apply_cc_fee_to_debit
			)
			&& (this.state.showCreditCardButtons || this.state.showDebitCardButtons)
		) {
			void this.persistCcFeeForKiosk();
		}

		const prevPkey = prevState.pkey ? parseInt(prevState.pkey, 10) : 0;
		const nextPkey = this.state.pkey ? parseInt(this.state.pkey, 10) : 0;
		if (nextPkey > 0 && prevPkey !== nextPkey) {
			void this.loadKioskSharing();
			void this.persistCcFeeForKiosk();
		} else if (prevPkey > 0 && nextPkey <= 0 && this.state.sharedKiosk != null) {
			this.setState({
				sharedKiosk: null,
				shared_kiosk_error: ""
			});
		}

		if (this.state.pkey
			&& this.state.loaded
			&& prevState.loaded
			&& prevState.pkey === this.state.pkey
			&& prevState.client !== this.state.client) {
			this.queueClientPersist(this.state.client);
		}

		if (this.state.loaded && isRegisterUnset(this.state.register)) {
			this.applyPreferredRegisterIfNeeded();
		}
	}

	componentWillUnmount() {
		if (this.clientSaveTimeout) {
			clearTimeout(this.clientSaveTimeout);
			this.clientSaveTimeout = null;
		}
		if (this._ccFeeRootSub != null && this.props.rootState && typeof this.props.rootState.unsubscribe === 'function') {
			this.props.rootState.unsubscribe(this._ccFeeRootSub);
			this._ccFeeRootSub = null;
		}
		if (super.componentWillUnmount) {
			super.componentWillUnmount();
		}
	}

	applyScannedCustomer = async (scan) => {
		const customer = scan && scan.customer ? scan.customer : null;
		if (!customer || !customer.pkey) {
			return;
		}

		this.afterCustomerSave(customer);
		if (this.state.pkey) {
			const checkout = new API.BuildClass(Types.Checkouts._name, API.RequestType.UPDATE);
			checkout.object.pkey = this.state.pkey;
			checkout.object.customer = customer.pkey;
			await checkout.submit(null, 'POST_CUSTOMER', true);
		}
	};

	// async findItemCount() {
	//
	// 	let itemsCount = this.state.itemsCount;
	//
	// 	//Get items
	// 	let itemsContainer = this.state.items
	// 	itemsContainer?.forEach((item) => {
	// 		itemsCount += item.quantity;
	// 	})
	//
	// 	//Add Products
	// 	itemsCount += this?.state?.products?.length ?? 0;
	//
	// 	//Get consignments - Consignment's don't technically have items, so they will usually be a quantity of one.
	// 	let consignmentsContainer = this.state?.consignments;
	// 	consignmentsContainer?.forEach((consignment) => {
	// 		itemsCount += consignment.quantity;
	// 	})
	//
	// 	itemsCount += this?.state?.layaways?.length > 0 ? 1 : 0
	//
	// 	//Updates badge on side nav
	// 	this.props.rootState.set({
	// 		session_items_count: itemsCount
	// 	})
	//
	// }

	loadSelfAfter(data) {
		if (data.pkey) {
			this.setState({"creator_name": data.creator_name});
			this.setState({"locations": data.locations});
			this.setState({"order_id": data.pkey});

			if (this.state.discount_percentage === 0) {
				this.setState({"discount_percentage": "0"});
			}

			void this.loadCustomerMembershipDiscounts(data.customer);
			void this.loadCustomerMemberships(data.customer);
			void this.refreshCheckoutItems();
			void this.loadKioskSharing();
		}
	}

	loadKioskSharing = async () => {
		try {
			const kiosksModel = new API.BuildClass(Types.Kiosks._name, API.RequestType.READ_ALL);
			kiosksModel.limit = 1000;
			const data = await kiosksModel.submit(null, API.RequestType.READ_ALL);
			const items = Array.isArray(data?.items)
				? data.items
				: (Array.isArray(data) ? data : []);
			const hasKiosks = items.length > 0;

			if (!this.state.pkey) {
				this.setState({
					hasKiosks,
					sharedKiosk: null,
					shared_kiosk_error: ""
				});
				return;
			}

			const checkoutPkey = parseInt(this.state.pkey, 10);
			const linked = items.find((kiosk) => parseInt(kiosk.checkout, 10) === checkoutPkey);

			this.setState({
				hasKiosks,
				sharedKiosk: linked ? linked.pkey : null,
				shared_kiosk_error: ""
			});
		} catch (e) {
			// Fail open so the Select can still load options if the count request errors.
			this.setState({
				hasKiosks: true,
				sharedKiosk: null,
				shared_kiosk_error: ""
			});
		}
	}

	isKioskAvailableForSharing = (kiosk) => {
		if (!kiosk) {
			return false;
		}

		const checkoutPkey = parseInt(this.state.pkey, 10);
		const kioskCheckout = kiosk.checkout ? parseInt(kiosk.checkout, 10) : null;

		return !kioskCheckout || kioskCheckout === checkoutPkey;
	}

	handleKioskShareUpdate = async (property, value) => {
		if (!this.state.pkey) {
			return;
		}

		if (!value) {
			await this.stopKioskSharing();
			return;
		}

		const kioskModel = new API.BuildClass(Types.Kiosks._name, API.RequestType.UPDATE);
		kioskModel.object.pkey = value;
		kioskModel.object.checkout = this.state.pkey;

		console.log("logging the kiosk model: ", kioskModel);

		try {
			await this.persistCcFeeForKiosk();
			await kioskModel.submit(null, "POST_LINK_CHECKOUT", true);
			this.setState({
				sharedKiosk: value,
				shared_kiosk_error: ""
			});
			toast.success("Sharing this sale to the selected kiosk.");
		} catch (e) {
			const message = e && e.responseJSON && e.responseJSON.message
				? e.responseJSON.message
				: "Unable to share to that kiosk.";
			this.setState({shared_kiosk_error: message});
			toast.error(message);
		}
	}

	stopKioskSharing = async () => {
		if (!this.state.sharedKiosk) {
			return;
		}

		const kioskModel = new API.BuildClass(Types.Kiosks._name, API.RequestType.UPDATE);
		kioskModel.object.pkey = this.state.sharedKiosk;

		try {
			await kioskModel.submit(null, "POST_UNLINK_CHECKOUT", true);
			this.setState({
				sharedKiosk: null,
				shared_kiosk_error: ""
			});
			toast.success("Stopped sharing to kiosk.");
		} catch (e) {
			const message = e && e.responseJSON && e.responseJSON.message
				? e.responseJSON.message
				: "Unable to stop kiosk sharing.";
			this.setState({shared_kiosk_error: message});
			toast.error(message);
		}
	}

	queueClientPersist = (client) => {
		if (this.clientSaveTimeout) {
			clearTimeout(this.clientSaveTimeout);
		}
		this.clientSaveTimeout = setTimeout(() => {
			this.clientSaveTimeout = null;
			void this.persistCheckoutClient(client == null ? '' : String(client));
		}, 400);
	}

	persistCheckoutClient = async (client) => {
		if (!this.state.pkey) {
			return;
		}
		const checkout = new API.BuildClass(Types.Checkouts._name, API.RequestType.UPDATE);
		checkout.object.pkey = this.state.pkey;
		checkout.object.customer = this.state.customer || null;
		checkout.object.client = client || '';
		await checkout.submit(null, 'POST_CUSTOMER', true);
	}

	loadCustomerMembershipDiscounts = async (customerPkey) => {
		const normalizedCustomerPkey = parseInt(customerPkey, 10);
		if (!Number.isFinite(normalizedCustomerPkey) || normalizedCustomerPkey <= 0) {
			this.membershipDiscountCustomerPkey = null;
			this.customerMembershipCustomerPkey = null;
			this.setState({
				membership_inventory_group_discounts: [],
				customer_memberships: [],
				membershipDiscountCustomer: null,
				customerMembershipsLoading: false,
			});
			return;
		}

		this.membershipDiscountCustomerPkey = normalizedCustomerPkey;
		this.setState({
			membershipDiscountCustomer: normalizedCustomerPkey,
		});

		try {
			const data = await $.ajax({
				type: 'GET',
				url: `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/memberships/customer_discounts/${normalizedCustomerPkey}`,
			});
			const response = data && typeof data.response !== 'undefined' ? data.response : data;
			const discounts = Array.isArray(response?.discounts) ? response.discounts : [];
			if (this.membershipDiscountCustomerPkey === normalizedCustomerPkey) {
				this.setState({
					membership_inventory_group_discounts: discounts,
					membershipDiscountCustomer: normalizedCustomerPkey,
				});
			}
		} catch (error) {
			if (this.membershipDiscountCustomerPkey === normalizedCustomerPkey) {
				this.setState({
					membership_inventory_group_discounts: [],
					membershipDiscountCustomer: normalizedCustomerPkey,
				});
			}
		}
	};

	loadCustomerMemberships = async (customerPkey) => {
		const normalizedCustomerPkey = parseInt(customerPkey, 10);
		if (!Number.isFinite(normalizedCustomerPkey) || normalizedCustomerPkey <= 0) {
			this.customerMembershipCustomerPkey = null;
			this.setState({
				customer_memberships: [],
				customerMembershipsLoading: false,
			});
			return;
		}

		this.customerMembershipCustomerPkey = normalizedCustomerPkey;
		this.setState({customerMembershipsLoading: true});

		try {
			const requestType = "GET_CUSTOMER_MEMBERSHIPS";
			const requestModel = new API.BuildClass(Types.Memberships._name, requestType);
			requestModel.object = {
				customer_lookup: normalizedCustomerPkey,
				include_activity: false,
			};
			const response = await requestModel.submit(null, requestType, true);
			const memberships = Array.isArray(response?.memberships) ? response.memberships : [];
			if (this.customerMembershipCustomerPkey === normalizedCustomerPkey) {
				this.setState({
					customer_memberships: memberships,
					customerMembershipsLoading: false,
				});
			}
		} catch (error) {
			if (this.customerMembershipCustomerPkey === normalizedCustomerPkey) {
				this.setState({
					customer_memberships: [],
					customerMembershipsLoading: false,
				});
			}
		}
	};

	handleCustomerSelectUpdate = (name, pkey, name_plural, data) => {
		this.handleSelectPropertyUpdate(name, pkey, name_plural, data);
		void this.loadCustomerMembershipDiscounts(pkey);
		void this.loadCustomerMemberships(pkey);
	};

	async loadItems() {
		this.state.items = [];
		let items = new API.BuildClass(Types.Checkouts_Items._name, API.RequestType.READ_ALL);
		items.parent = this.state.pkey
		let data = await items.submit(null, API.RequestType.READ_ALL)
		this.setState({ items: data.items }, this.recalculateTotals);
	}

	async loadLayaways() {
		this.state.layaways = [];
		let layaways = new API.BuildClass(Types.Checkouts_Layaways._name, API.RequestType.READ_ALL);
		layaways.parent = this.state.pkey
		let data = await layaways.submit(null, API.RequestType.READ_ALL)
		this.setState({layaways: data.items}, this.recalculateTotals)
	}

	async loadWorkOrders() {
		this.state.work_orders = [];
		let work_orders = new API.BuildClass(Types.Checkouts_Work_Orders._name, API.RequestType.READ_ALL);
		work_orders.parent = this.state.pkey
		let data = await work_orders.submit(null, API.RequestType.READ_ALL)
		this.setState({work_orders: data.items}, this.recalculateTotals)
	}

	async loadTrades() {
		this.state.trades = [];
		let items = new API.BuildClass(Types.Checkouts_Trades._name, API.RequestType.READ_ALL);
		items.parent = this.state.pkey
		let data = await items.submit(null, API.RequestType.READ_ALL)
		this.setState({trades: data.items}, () => {
			this.recalculateTotals();
			this.syncSessionItemsCount();
		})
	}

	async loadConsignments() {
		this.state.consignments = [];
		let consignments = new API.BuildClass(Types.Checkouts_Consignments._name, API.RequestType.READ_ALL);
		consignments.parent = this.state.pkey
		let data = await consignments.submit(null, API.RequestType.READ_ALL)
		this.setState({consignments: data.items}, this.recalculateTotals)
	}

	async loadServices() {
		this.state.services = [];
		const services = new API.BuildClass(Types.Checkouts_Services._name, API.RequestType.READ_ALL);
		services.parent = this.state.pkey;
		const data = await services.submit(null, API.RequestType.READ_ALL);
		this.setState({services: data.items || []}, this.recalculateTotals);
	}

	async loadProducts() {
		let products = new API.BuildClass(Types.Checkouts_Products._name, API.RequestType.READ_ALL);
		products.parent = this.state.pkey;
		let data = await products.submit(null, API.RequestType.READ_ALL);
		const checkoutProducts = Array.isArray(data?.items) ? data.items : [];

		if (checkoutProducts.length <= 0) {
			this.setState({products: [], product_information: [], keys: Math.random()}, this.recalculateTotals);
			return;
		}

		const pkeys = checkoutProducts.map((item) => item.product);
		let product = new API.BuildClass(Types.Inventories_Connected._name, 'GET_ALL');
		product.search = `=${pkeys.map((pkey) => `pkey:${pkey};`).join('')}`;
		product.limit = 1000;
		let theProduct = await product.submit(null, API.RequestType.READ_ALL);
		const inventoryProducts = Array.isArray(theProduct?.items) ? theProduct.items : [];

		const inventoryByPkey = new Map(inventoryProducts.map((inv) => [inv.pkey, inv]));
		const mergedProducts = checkoutProducts.map((checkoutProduct) => {
			const inv = inventoryByPkey.get(checkoutProduct.product) || {};
			const manufacturerName = inv.manufacturers ? inv.manufacturers.name : inv.manufacturer_other;
			const defaultName = `${manufacturerName || ''} ${inv.model || ''} ${inv.type || ''}`.trim();
			return {
				...inv,
				checkout: checkoutProduct.pkey,
				taxable: catalogTaxable(checkoutProduct.taxable, true),
				name: checkoutProduct.name || defaultName,
				serial: checkoutProduct.serial || inv.serial_number,
				sku: checkoutProduct.sku || inv.sku,
				cost: checkoutProduct.cost || inv.price_list
			};
		});

		this.setState({
			product_information: inventoryProducts,
			products: mergedProducts,
			keys: Math.random()
		}, this.recalculateTotals);
	}

	handleAmountFocus = (event) => {
		const fieldName = event.currentTarget.name;
		if (!isUnsetPaymentAmount(this.state[fieldName])) {
			return;
		}
		const totals = this.recalculateTotals();
		if (fieldName === 'invoice_amount') {
			if (!checkoutInvoiceAllowed(totals)) {
				return;
			}
			const maxInvoice = checkoutMaxInvoiceAmount(
				{ ...this.state, invoice_amount: '0.00' },
				totals
			);
			const fill = Math.min(parseFloat(checkoutPaymentFillAmount(totals)) || 0, maxInvoice);
			if (fill > TOLERANCE) {
				this.handleInvoiceAmountChange(fieldName, fill.toFixed(2));
			}
			return;
		}
		this.setState({[fieldName]: checkoutPaymentFillAmount(totals), [`${fieldName}_error`]: ''});
	};

	//Removes a BPOS Item
	removeItemFromCart = async (pkey, quantity) => {
		this.setState({loading: true});
		setTimeout(async () => {
			let item = new API.BuildClass(Types.Checkouts_Items._name, API.RequestType.DELETE);
			item.object.pkey = pkey
			item.parent = this.state.pkey
			let currentCount = this.props.rootState.session_items_count;
			await item.submit(null, API.RequestType.DELETE).then(() => {
				this.loadItems()
				this.setState({loading: false})
				this.props.rootState.set({ session_items_count: currentCount - quantity })
			})
		}, 500)

	};

	removeTradeFromCart = async (pkey, quantity) => {
		this.setState({loading: true});
		setTimeout(async () => {
			let item = new API.BuildClass(Types.Checkouts_Trades._name, API.RequestType.DELETE);
			item.object.pkey = pkey
			item.parent = this.state.pkey
			let currentCount = this.props.rootState.session_items_count
			await item.submit(null, API.RequestType.DELETE).then(() => {
				this.loadTrades()
				this.setState({loading: false})
				this.props.rootState.set({ session_items_count: currentCount - quantity })
			})
		}, 500)

	};

	removeConsignmentFromCart = async (pkey) => {
		// this.setState({loading:true});
		setTimeout(async () => {
			let item = new API.BuildClass(Types.Checkouts_Consignments._name, API.RequestType.DELETE);
			item.object.pkey = pkey
			item.parent = this.state.pkey
			let currentCount = this.props.rootState.session_items_count;
			// noinspection JSIgnoredPromiseFromCall
			await item.submit(null, API.RequestType.DELETE).then(() => {
				this.loadConsignments()
				this.setState({loading: false})
				this.props.rootState.set({ session_items_count: currentCount - 1 });
			})
		}, 500)
	};

	removeServiceFromCart = async (pkey, quantity) => {
		setTimeout(async () => {
			const item = new API.BuildClass(Types.Checkouts_Services._name, API.RequestType.DELETE);
			item.object.pkey = pkey;
			item.parent = this.state.pkey;
			const currentCount = this.props.rootState.session_items_count;
			await item.submit(null, API.RequestType.DELETE).then(() => {
				void this.loadServices();
				this.setState({loading: false});
				this.props.rootState.set({session_items_count: currentCount - (quantity || 1)});
			});
		}, 500);
	};

	updateItemQuantityValue = (index, inventory, pkey) => event => {
		const re = /^[0-9\b]+$/;
		// if value is not blank, then test the regex
		if (event.currentTarget.value === '' || (event.currentTarget.value !== '0' && re.test(event.currentTarget.value))) {
			let items = this.state.items;
			items[index].quantity = event.currentTarget.value !== '' ? parseFloat(event.currentTarget.value) : '';
			// this.setState({items: items});
			if (items[index].quantity !== "" && items[index].quantity !== 0) {
				void this.updateItemQuantity(pkey, inventory, event.currentTarget.value);
			}
		}
	};

	updateSingularDiscount = (index, inventory, pkey, table) => event => {
		if (table === 'item') {
			let items = this.state.items;
			items[index].discount_amount = event.currentTarget.value;
			this.setState({items: items});
		}
		if (table === 'consignment') {
			let items = this.state.consignments;
			items[index].discount_amount = event.currentTarget.value;
			this.setState({consignments: items});
		}
		if (table === 'product') {
			let items = this.state.products;
			items[index].discount_amount = event.currentTarget.value;
			this.setState({products: items});
		}
		if (table === 'service') {
			const items = this.state.services;
			items[index].discount_amount = event.currentTarget.value;
			this.setState({services: items});
		}
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			if (table === 'item') {
				void this.updateItemQuantity(pkey, inventory, this.state.items[index].discount_amount, true);
			}
			if (table === 'consignment') {
				void this.updateConsignmentQuantity(pkey, inventory, this.state.consignments[index].discount_amount, true);
			}
			if (table === 'product') {
				void this.updateProductDiscount(pkey, this.state.products[index].discount_amount);
			}
			if (table === 'service') {
				void this.updateServiceQuantity(pkey, this.state.services[index].discount_amount, true);
			}
		}, 800);
	};

	//check where it calls loaditems and see why state isnt undefined there

	async updateCheckoutTaxable(classname, pkey, value, preventLoading = false) {
		const modelName = CHECKOUT_LINE_TYPES[classname];
		if (!modelName) {
			return;
		}
		let item = new API.BuildClass(modelName, API.RequestType.UPDATE)
		item.parent = this.state.pkey;
		item.object = {
			pkey: pkey,
			checkout: this.state.pkey,
			taxable: value,
		};
		if (classname === "Services") {
			const line = (this.state.services || []).find((row) => row.pkey === pkey);
			if (line) {
				item.object.quantity = parseInt(line.quantity, 10) || 1;
			}
		}
		await item.submit(null, API.RequestType.UPDATE, true)
		if (preventLoading) {
			return;
		}
		void this.refreshCheckoutItems()
	}

	async updateProductDiscount(pkey, discount) {
		let item = new API.BuildClass(Types.Checkouts_Products._name, API.RequestType.UPDATE)
		item.parent = this.state.pkey;

		item.object = {
			pkey: pkey,
			checkout: this.state.pkey,
			discount_amount: discount
		}
		await item.submit(null, API.RequestType.UPDATE, true)
		await this.loadItems();
	};

	async updateItemQuantity(pkey, inventory, quantity, discounting_singular = false) {
		let item = new API.BuildClass(Types.Checkouts_Items._name, API.RequestType.UPDATE)
		item.parent = this.state.pkey;
		if (discounting_singular) {
			item.object = {
				pkey: pkey,
				inventory: inventory,
				checkout: this.state.pkey,
				discount_amount: quantity
			}
		} else {
			item.object = {
				pkey: pkey,
				inventory: inventory,
				checkout: this.state.pkey,
				quantity: quantity
			}
		}
		await item.submit(null, API.RequestType.UPDATE, true)
		await this.loadItems();
	};

	async updateConsignmentQuantity(pkey, inventory, quantity, discounting_singular = false) {
		let item = new API.BuildClass(Types.Checkouts_Consignments._name, API.RequestType.UPDATE)
		item.parent = this.state.pkey;
		if (discounting_singular) {
			item.object = {
				pkey: pkey,
				inventory: inventory,
				checkout: this.state.pkey,
				discount_amount: quantity
			}
		} else {
			item.object = {
				pkey: pkey,
				inventory: inventory,
				checkout: this.state.pkey,
				quantity: quantity
			}
		}
		await item.submit(null, API.RequestType.UPDATE, true)
		await this.loadConsignments();
	};

	async updateServiceQuantity(pkey, quantityOrDiscount, discounting_singular = false) {
		const item = new API.BuildClass(Types.Checkouts_Services._name, API.RequestType.UPDATE);
		item.parent = this.state.pkey;
		if (discounting_singular) {
			item.object = {
				pkey: pkey,
				checkout: this.state.pkey,
				discount_amount: quantityOrDiscount,
			};
		} else {
			item.object = {
				pkey: pkey,
				checkout: this.state.pkey,
				quantity: quantityOrDiscount,
			};
		}
		await item.submit(null, API.RequestType.UPDATE, true);
		await this.loadServices();
	}

	removeProductFromCart = async (pkey) => {
		setTimeout(async () => {
			let item = new API.BuildClass(Types.Checkouts_Products._name, API.RequestType.DELETE);

			item.object.pkey = pkey
			item.parent = this.state.pkey
			let currentCount = this.props.rootState.session_items_count;
			try {
				await item.submit(null, API.RequestType.DELETE);
				await this.loadProducts();
				this.props.rootState.set({ session_items_count: currentCount - 1 });
			} finally {
				this.setState({loading: false});
			}
		}, 500)
	};

	removeLayawayFromCart = async (pkey) => {
		setTimeout(async () => {
			let item = new API.BuildClass(Types.Checkouts_Layaways._name, API.RequestType.DELETE);

			item.object.pkey = pkey
			item.parent = this.state.pkey
			let currentCount = this.props.rootState.session_items_count;
			try {
				await item.submit(null, API.RequestType.DELETE);
				await this.loadLayaways();
				this.props.rootState.set({ session_items_count: currentCount - 1 })
			} finally {
				this.setState({loading: false})
			}
		}, 500)
	};

	removeWorkOrderFromCart = async (pkey) => {
		setTimeout(async () => {
			let item = new API.BuildClass(Types.Checkouts_Work_Orders._name, API.RequestType.DELETE);

			item.object.pkey = pkey
			item.parent = this.state.pkey
			let currentCount = this.props.rootState.session_items_count;
			try {
				await item.submit(null, API.RequestType.DELETE);
				await this.loadWorkOrders();
				this.props.rootState.set({ session_items_count: currentCount - 1 })
			} finally {
				this.setState({loading: false})
			}
		}, 500)
	};

	toggleManualCard = async () => {
		this.setState({manual_card: !this.state.manual_card});
	}

	toggleOtherPaymentsManual = async () => {
		this.setState({manual: !this.state.manual});

		//set things back to zero, so it can actually go back
		if (this.state.manual) {
			this.setState({
				other_amount: "0.00",
				check_amount: "0.00",
				zelle_amount: "0.00",
				cash_amount: "0.00",
				invoice_amount: "0.00"
			});
		}

		let showRegister = this.state.showRegister;
		(showRegister ? this.setState({showRegister: false}) : this.setState({showRegister: true}))

	}

	toggleOtherFields = async () => {
		this.setState({optionalFields: !this.state.optionalFields});

		let showOtherFields = this.state.showOtherFields;
		(showOtherFields ? this.setState({showOtherFields: false}) : this.setState({showOtherFields: true}))

	}

	async pause() {
		await this.model.submit(this, API.RequestType.UPDATE)
		await this.persistCcFeeForKiosk();
		this.props.history.push("/sessions")
		this.props.rootState.set({
			session_items_count: 0
		})
	}

	ensureContractCardAmount = () => {
		if (!checkoutIsContractPayment(this.state) || !isUnsetPaymentAmount(this.state.card_amount)) {
			return;
		}
		const totals = this.recalculateTotals();
		const remaining = parseFloat(totals.remaining);
		if (Number.isFinite(remaining) && remaining > TOLERANCE) {
			this.state.card_amount = remaining.toFixed(2);
		}
	};

	async checkout(request) {
		// Split tender on layaway/work order: Complete with card_amount → terminal for card portion only.
		// Never downgrade an explicit Charge Card (POST_TERMINAL) to cash.
		if (checkoutIsContractPayment(this.state) && request !== 'POST_CARD') {
			if (request === 'POST_CASH' && !isUnsetPaymentAmount(this.state.card_amount)) {
				request = 'POST_TERMINAL';
			}
		}
		this.update = request;
		if (this.update === 'POST_TERMINAL') {
			this.ensureContractCardAmount();
		}
		const totals = this.recalculateTotals();
		const amount = parseFloat(totals.amount);
		if (amount < -0.005) {
			confirmAlert({
				title: 'Confirm disbursement',
				message: `Pay out $${Math.abs(amount).toFixed(2)} to the customer?`,
				buttons: [
					{
						label: 'Yes',
						onClick: async () => {
							await this.handleSubmit(null);
							this.props.rootState.set({ session_items_count: 0 });
						},
					},
					{ label: 'No', onClick: () => {} },
				],
			});
		} else if (Math.abs(amount) <= 0.005) {
			confirmAlert({
				title: 'Confirm Transaction',
				message: 'Are you sure you want to checkout for $0?',
				buttons: [
					{
						label: 'Yes',
						onClick: async () => {
							await this.handleSubmit(null);
							this.props.rootState.set({ session_items_count: 0 });
						},
					},
					{ label: 'No', onClick: () => {} },
				],
			});
		} else {
			await this.handleSubmit(null);
			this.props.rootState.set({ session_items_count: 0 });
		}
	};

	startTerminalTransaction = async () => {

		if (this.state.loading) return;

		this.toggleLoading(true);

		return new Promise((resolve, reject) => {
			const beforeObject = this.model.object;

			this.model.object = this.state;
			this.model.submitCancelable(
				this.terminalRequest,
				this.update,
				async (data) => {
					this.toggleLoading(false);
					await this.afterSubmit(data)
					resolve(data);
				}
			);

			this.model.object = beforeObject;

			// Detect abort rejection
			$(this.terminalRequest).on('abort', () => {
				this.toggleLoading(false);
				reject('aborted');
			});

		});
	};

	handleSubmit = async () => {
		this.state.invoice_amount = formatCheckoutPaymentAmount(this.state.invoice_amount);
		if (this.state.showCheckField && isUnsetPaymentAmount(this.state.check_amount)) {
			const preTotals = this.recalculateTotals();
			const amount = parseFloat(preTotals.amount);
			if (amount < -TOLERANCE) {
				this.state.check_amount = Math.abs(amount).toFixed(2);
			}
		}
		if (this.state.showZelleField && isUnsetPaymentAmount(this.state.zelle_amount)) {
			const preTotals = this.recalculateTotals();
			const amount = parseFloat(preTotals.amount);
			if (amount < -TOLERANCE) {
				this.state.zelle_amount = Math.abs(amount).toFixed(2);
			}
		}
		this.state.is_debit = !!this.state.showDebitCardButtons;
		const totals = this.recalculateTotals();
		for (const totalKey of Object.keys(totals)) {
			if (totalKey === 'tax_summary') continue;
			this.state[totalKey] = totals[totalKey];
		}
		if (this.state.cash_discount_amount && parseFloat(this.state.cash_discount_amount) > 0) {
			this.state.cash_discount_amount = this.state.cash_discount_amount.toFixed(2)
			this.state.cash_discount_percentage = this.props.rootState.cash_discount_percentage;
		}
		if (!this.validatePayByLinkRequirements()) {
			return;
		}
		if (this.state.layaway && !this.state.layawayPkey) {
			confirmAlert({
				title: 'Confirm Transaction',
				message: 'Are you sure you want to start a layaway?',
				buttons: [
					{
						label: 'Yes',
						onClick: async () => {
							if (!this.validatePayByLinkRequirements()) {
								return;
							}
							await super.handleSubmit(null);
						}
					},
					{
						label: 'No',
						onClick: () => {
						}
					}
				]
			});
		} else if (this.state.work_order && !this.state.workOrderPkey) {
			confirmAlert({
				title: 'Confirm Transaction',
				message: 'Are you sure you want to start a work order?',
				buttons: [
					{
						label: 'Yes',
						onClick: async () => {
							if (!this.validatePayByLinkRequirements()) {
								return;
							}
							await super.handleSubmit(null);
						}
					},
					{
						label: 'No',
						onClick: () => {
						}
					}
				]
			});
		} else if (this.update === 'POST_TERMINAL') {
			if (!this.validatePayByLinkRequirements()) {
				return;
			}
			this.ensureContractCardAmount();
			try {
				await this.startTerminalTransaction();

			} catch (e) {
				if (e !== 'aborted') {
					API.Toast.error("There was an error processing the transaction. The error was : " + e, {
						position: API.Toast.POSITION.TOP_RIGHT,
						autoClose: 10000
					})
				}
			}
		} else {
			await super.handleSubmit(null);
		}
	}

	validatePayByLinkRequirements = () => {
		const {rootState} = this.props;
		const invoiceAmount = parseFloat(this.state.invoice_amount || 0);
		if (!rootState.invoicing_enabled || !rootState.pay_by_link_enabled || !rootState.altrupay_linked || invoiceAmount <= 0) {
			return true;
		}
		const receiptEmail = (this.state.receipt_email || "").trim();
		const customerEmail = this.state.customers && this.state.customers.email
			? String(this.state.customers.email).trim()
			: "";
		const email = receiptEmail || customerEmail;
		if (!email) {
			API.Toast.error("An email receipt address or customer email is required when using To Invoice with pay-by-link invoicing.", {
				position: API.Toast.POSITION.TOP_RIGHT,
			});
			return false;
		}
		return true;
	};

	async afterSubmit(data) {
		if (this.state.layaway) {
			this.props.history.push("/layaways/" + data.pkey);
		} else if (this.state.work_order) {
			this.props.history.push("/work-orders/" + data.pkey);
		} else {
			this.props.history.push("/transactions/" + data.pkey);
		}
	}

	handleAlignment = (event, alignment) => {
		if (alignment === "amount") {
			this.setState({discount_percentage: '0'});
		} else {
			this.setState({discount_amount: '0.00'});
		}
		this.setState({alignment});
	};

	addGiftCertificateRow = () => {
		this.setState(prevState => ({
			gift_certificates: [
				...prevState.gift_certificates,
				{ pkey: null, name: '', value: 0, amount: '0.00', error: '' }
			]
		}));
	}

	removeGiftCertificateRow = (index) => {
		this.setState(prevState => {
			const gift_certificates = prevState.gift_certificates.filter((_, i) => i !== index);
			let other_amount = 0;
			gift_certificates.forEach(row => {
				const amt = parseFloat(row.amount);
				if (!isNaN(amt)) {
					other_amount += amt;
				}
			});
			return { gift_certificates, other_amount };
		});
	}

	sumGiftCertificateAmounts = (gift_certificates) => {
		let other_amount = 0;
		gift_certificates.forEach(row => {
			const amt = parseFloat(row.amount);
			if (!isNaN(amt)) {
				other_amount += amt;
			}
		});
		return other_amount;
	}

	handleGiftCertificateSelect = (index, pkey, certObject) => {
		if (pkey) {
			const duplicate = this.state.gift_certificates.some(
				(row, i) => i !== index && row.pkey && String(row.pkey) === String(pkey)
			);
			if (duplicate) {
				API.ToastId = toast.error('This gift certificate is already selected.', {
					position: toast.POSITION.TOP_CENTER
				});
				return;
			}
		}

		this.setState(prevState => {
			const gift_certificates = prevState.gift_certificates.map((row, i) => {
				if (i !== index) {
					return row;
				}
				if (!pkey) {
					return { pkey: null, name: '', value: 0, amount: '0.00', error: '' };
				}
				const certValue = parseFloat(certObject?.value ?? 0);
				return {
					pkey,
					name: certObject?.name ?? '',
					value: certValue,
					amount: Number.isFinite(certValue) ? certValue.toFixed(2) : '0.00',
					error: '',
				};
			});
			return {
				gift_certificates,
				other_amount: this.sumGiftCertificateAmounts(gift_certificates),
			};
		});
	}


	handleGiftCertificateAmountChange = (index, property, value) => {
		if (value === undefined || value === null) {
			value = "";
		}

		const regex = /^\d*\.?\d{0,2}$/;
		if (!regex.test(value)) {
			// Invalid input like too many decimals, letters, etc.
			return;
		}

		this.setState(prevState => {
			// Clone gift certificates
			let gift_certificates = JSON.parse(JSON.stringify(prevState.gift_certificates));

			let currentCert = gift_certificates[index];
			currentCert.amount = value; // Store the raw input for the text field

			// For calculations, parseFloat safely only if valid
			const numericValue = parseFloat(value);
			const numericLimit = parseFloat(currentCert.value);

			if (!isNaN(numericValue)) {
				if (numericValue > numericLimit) {
					currentCert.amount = numericLimit.toFixed(2); // Cap it
				}
			}

			// Recalculate other_amount
			const other_amount = this.sumGiftCertificateAmounts(gift_certificates);

			return { gift_certificates, other_amount };
		});
	};

	handleScannedGiftCertificate = async (pkey) => {
		try {
			const model = new API.BuildClass(Types.Certificates._name, API.RequestType.READ);
			model.object.pkey = pkey;
			model.parent = pkey;
			const cert = await model.submit(null, API.RequestType.READ);
			if (!cert || cert.used) {
				API.ToastId = toast.error('Certificate not found or already used.', {
					position: toast.POSITION.TOP_CENTER
				});
				return;
			}

			const duplicate = this.state.gift_certificates.some(
				row => row.pkey && String(row.pkey) === String(pkey)
			);
			if (duplicate) {
				API.ToastId = toast.error('This gift certificate is already selected.', {
					position: toast.POSITION.TOP_CENTER
				});
				return;
			}

			if (!this.state.showGiftCertField) {
				this.setState({
					showGiftCertField: true,
					gift_certificates: [
						{ pkey: null, name: '', value: 0, amount: '0.00', error: '' }
					],
					other_amount: '0.00',
				}, () => {
					this.handleGiftCertificateSelect(0, cert.pkey, cert);
				});
				return;
			}

			const emptyIndex = this.state.gift_certificates.findIndex(row => !row.pkey);
			if (emptyIndex === -1) {
				this.setState(prevState => ({
					gift_certificates: [
						...prevState.gift_certificates,
						{ pkey: null, name: '', value: 0, amount: '0.00', error: '' }
					]
				}), () => {
					this.handleGiftCertificateSelect(this.state.gift_certificates.length - 1, cert.pkey, cert);
				});
			} else {
				this.handleGiftCertificateSelect(emptyIndex, cert.pkey, cert);
			}
		} catch (error) {
			API.ToastId = toast.error('Certificate not found or already used.', {
				position: toast.POSITION.TOP_CENTER
			});
		}
	}


	handleAmountChange = (property, value) => {
		this.handleTextFieldPropertyUpdate(property, value)
	}

	handleInvoiceAmountChange = (property, value) => {
		const totals = this.recalculateTotals();
		if (!checkoutInvoiceAllowed(totals)) {
			this.handleTextFieldPropertyUpdate(property, '0.00');
			return;
		}
		const maxInvoice = checkoutMaxInvoiceAmount(
			{ ...this.state, invoice_amount: '0.00' },
			totals
		);
		let amount = parseFloat(value);
		if (!Number.isFinite(amount) || amount < 0) {
			amount = 0;
		}
		if (amount > maxInvoice + TOLERANCE) {
			amount = maxInvoice;
		}
		this.handleTextFieldPropertyUpdate(property, amount.toFixed(2));
	}

	handleDateChange = (property, value) => {
		value = moment(value).format("MM/YY")
		this.setState({card_expiry: value})
		this.handleTextFieldPropertyUpdate(property, value)
	}

	async handleTaxableStatus(object, type) {
		//add products back in later
		const checkouts = {items: "Items", consignments: "Consignments", products: "Products", services: "Services"};
		try {
			const updates = Object.keys(checkouts).flatMap((key) => {
				const records = object[key] || [];
				return records.map((item) => {
					//taxable is set to !type, didn't feel like ripping all of it out to fix
					const targetPkey = checkouts[key] === "Products" ? item.checkout : item.pkey;
					return this.updateCheckoutTaxable(checkouts[key], targetPkey, !type, true);
				});
			});
			await Promise.all(updates);
			await this.refreshCheckoutItems();
		} catch (e) {
			console.error(e);
		}
	}

	//Toggle between Taxable and non-taxable amounts
	toggleTax(object) {
		let taxable = object.taxable;
		if (taxable === false) {
			object.tax_amount = 0;
			object.amount = (Math.ceil((object.sub_total) * 100) / 100);
			object.remaining = object.amount
		}
		if (taxable === true) {
			const originalTax = object.tax_amount;
			object.tax = originalTax;
			object.amount = (Math.floor((object.sub_total + originalTax) * 100) / 100);
			object.remaining = object.amount;
		}
	}

	//Handles Taxable status of buttonGroup
	handleTypeChange = (event, type) => {
		type = false;
		let object = this.state;
		if (event.currentTarget.id === 'false') type = true;
		if (this.state.hasTaxableStatusChanged) {
			this.setState({ showAlert: true }, () => {
				API.Toast.info('You have changed the taxable status of the entire transaction.', {
					position: API.Toast.POSITION.TOP_RIGHT,
					autoClose: 10000,
				});
			});
		}
		this.setState({
			type: type,
			hasTaxableStatusChanged: false,
			showAlert: false
		});
		this.handleTaxableStatus(object, type);
	}

	handleRowClick = (item = null, product = null, consignment = null) => {
		if (item === null && product === null && consignment === null) {
			return;
		}
		this.itemRef = item || product || consignment;
		let format = null;
		//format the different items you can put into checkout, so it is easier to display and change later
		let newItemFormat = {
			name: this.itemRef.name,
			serial: this.itemRef.serial,
			sku: this.itemRef.sku,
			cost: this.itemRef.cost
		};
		if (item !== null) {
			format = 'item';
		}
		if (product !== null) {
			format = 'product';
		}
		if (consignment !== null) {
			// Service lines are passed via the consignment slot; distinguish from consignment rows.
			format = consignment.consignments != null ? 'consignment' : 'service';
		}
		this.setState({itemIsChanging: true, itemToChange: newItemFormat, itemFormat: format})
	}

	handleItemUpdate = (event) => {
		this.state.itemToChange[event.target.id] = event.target.value;
		this.setState({itemToChange: this.state.itemToChange});
	}

	handleSavingRowModal = async () => {
		this.itemRef.name = this.state.itemToChange.name;
		this.itemRef.serial = this.state.itemToChange.serial;
		this.itemRef.sku = this.state.itemToChange.sku;
		this.itemRef.cost = this.state.itemToChange.cost;
		this.setState({itemIsChanging: false})

		let rowModel = new API.BuildClass(Types.Checkouts._name, API.RequestType.UPDATE);

		//send the item to the backend, so it can update the checkout on the backend so everything is tip-top
		rowModel.object.changing_items = {...this.itemRef, 'format': this.state.itemFormat};

		try {
			await rowModel.submit(null, 'POST_ROW_EDIT', true);
			await this.refreshCheckoutItems();
			API.Toast.success("Saved!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
			console.error(e);
		}
	}

	clickableTD = (item, value, key, product = null, consignment = null, cash_discount = null) => {
		return (
			<td
				className="text-center"
				title="Edit"
				onMouseEnter={() => this.setState({['hover' + key]: "lightgray"})}
				onMouseLeave={() => this.setState({['hover' + key]: null})}
				style={{backgroundColor: this.state['hover' + key] || undefined, cursor: "pointer"}}
				onClick={() => this.handleRowClick(item, product, consignment)}
			>
				<span>
					{value}
					{cash_discount && <i style={{color: 'red', paddingLeft: 5}}>({cash_discount})</i>}
				</span>
			</td>
		);
	}

	handleTaxableToggle = async (className, pkey, taxable) => {
		this.setState({hasTaxableStatusChanged: true});
		await this.updateCheckoutTaxable(className, pkey, taxable);
	}

	renderTaxableButtons = (className, pkey, taxable) => {
		return (
			<ButtonGroup size={"md"}>
				<Button
					onClick={() => this.handleTaxableToggle(className, pkey, true)}
					outline={!!taxable === false}
					active={!!taxable === true}
					className='primary-button-buttongroup'
					color='primary'
				>
					Taxable
				</Button>
				<Button
					onClick={() => this.handleTaxableToggle(className, pkey, false)}
					outline={!!taxable === true}
					active={!!taxable === false}
					className='primary-button-buttongroup'
					color='primary'
				>
					Non-Taxable
				</Button>
			</ButtonGroup>
		);
	}

	getPaymentIconStyle = (isActive) => {
		return {
			backgroundColor: isActive ? '#16a34a' : '',
			color: isActive ? 'white' : '',
			borderRadius: isActive ? '50px' : '',
			cursor: 'pointer'
		};
	}

	handleTransactionType = () => {
		this.setState({layaway: !this.state.layaway});
	}

	//Function to ensure that Checkout badge is updating when quantity count is changed via TextField
	async handleQuantityInputChange(newValue, item) {
		const oldQuantity = item.quantity;
		let newQuantity = parseInt(newValue, 10) || 0;

		//Ensure that quantity in TextField is never less than 1
		if (newQuantity <= 0) {
			newQuantity = 1;
		}

		await this.updateItemQuantity(item.pkey, item.inventory, newQuantity);

		const quantityChange = newQuantity - oldQuantity;

		const currentCount = this.props.rootState.session_items_count || 0;

		this.props.rootState.set({
			session_items_count: currentCount + quantityChange
		});
	}

	handleServiceQuantityInputChange = async (newValue, serviceLine) => {
		const oldQuantity = parseInt(serviceLine.quantity, 10) || 1;
		let newQuantity = parseInt(newValue, 10) || 0;
		if (newQuantity < 1) {
			newQuantity = 1;
		}
		await this.updateServiceQuantity(serviceLine.pkey, newQuantity);
		const quantityChange = newQuantity - oldQuantity;
		const currentCount = this.props.rootState.session_items_count || 0;
		this.props.rootState.set({
			session_items_count: currentCount + quantityChange,
		});
	};

	// Functions that toggle the payment fields when the respective payment button is pressed
	toggleCashField = () => {
		this.setState(prevState => {
			const nextShowCashField = !prevState.showCashField;
			return {
				showCashField: nextShowCashField,
				cash_amount: "0.00",
				cash_discount_amount: null
			};
		}, () => {
			void this.persistCashDiscountMode();
		});
	}

	persistCashDiscountMode = async () => {
		return this.persistCcFeeForKiosk();
	}

	persistCcFeeForKiosk = async () => {
		if (!this.state.pkey) {
			return;
		}
		const flags = this.ccFeeFlags();
		const totals = this.recalculateTotals();
		const apply = checkoutShouldApplyCcFee(this.state, flags);
		const checkout = new API.BuildClass(Types.Checkouts._name, API.RequestType.UPDATE);
		checkout.object.pkey = this.state.pkey;
		if (this.state.location) {
			checkout.object.location = this.state.location;
		}
		if (this.state.register) {
			checkout.object.register = this.state.register;
		}
		checkout.object.cc_fee_amount = apply ? totals.cc_fee_amount : '0.00';
		checkout.object.kiosk_cc_fee = apply ? 1 : 0;
		const canCashDiscount = shouldApplyCashDiscount(this.props.rootState, this.state);
		if (canCashDiscount) {
			checkout.object.cash_discount_percentage = this.props.rootState.cash_discount_percentage;
		} else {
			checkout.object.cash_discount_percentage = 0;
			checkout.object.cash_discount_amount = 0;
		}
		try {
			await checkout.submit(null, 'POST_KIOSK_TENDER', true);
		} catch (e) {
			// Kiosk will keep previous CC fee / cash-discount until the next successful persist.
		}
	}

	toggleCheckField = () => {
		this.setState(prevState => ({
			showCheckField: !prevState.showCheckField,
			check_amount: "0.00"
		}), () => {
			void this.persistCashDiscountMode();
		});
	}

	toggleZelleField = () => {
		this.setState(prevState => ({
			showZelleField: !prevState.showZelleField,
			zelle_amount: "0.00"
		}), () => {
			void this.persistCashDiscountMode();
		});
	}

	toggleGiftCertField = () => {
		this.setState(prevState => {
			const opening = !prevState.showGiftCertField;
			return {
				showGiftCertField: opening,
				gift_certificates: opening
					? [{ pkey: null, name: '', value: 0, amount: '0.00', error: '' }]
					: [],
				other_amount: '0.00',
			};
		}, () => {
			void this.persistCashDiscountMode();
		});
	}

	toggleInvoiceField = () => {
		this.setState(prevState => ({
			showInvoiceField: !prevState.showInvoiceField,
			invoice_amount: '0.00',
			//invoice_amount_error: '',
		}), () => {
			void this.persistCashDiscountMode();
		});
	}

	toggleCreditCardButtons = () => {
		this.setState(prevState => {
			const opening = !prevState.showCreditCardButtons;
			const auto = isAutoCcFeeEnabled(this.ccFeeFlags());
			const isPlan2 = this.props.rootState.location_plan === 2;
			return {
				showCreditCardButtons: opening,
				showDebitCardButtons: opening ? false : prevState.showDebitCardButtons,
				is_debit: opening ? false : prevState.is_debit,
				manual_card: false,
				card_amount: "0.00",
				card_percentage: opening && auto ? true : (opening || !auto ? prevState.card_percentage : false),
				sudo_card: opening && auto && isPlan2
					? "card"
					: (opening || !auto ? prevState.sudo_card : ""),
			};
		}, () => {
			void this.persistCashDiscountMode();
		});
	}

	toggleDebitCardButtons = () => {
		this.setState(prevState => {
			const opening = !prevState.showDebitCardButtons;
			const flags = this.ccFeeFlags();
			const auto = isAutoCcFeeEnabled(flags);
			const applyDebitFee = isApplyCcFeeToDebitEnabled(flags);
			return {
				showDebitCardButtons: opening,
				showCreditCardButtons: opening ? false : prevState.showCreditCardButtons,
				is_debit: opening,
				card_percentage: opening && auto && applyDebitFee,
				sudo_card: opening ? "" : prevState.sudo_card,
				manual_card: false,
				card_amount: "0.00"
			};
		}, () => {
			void this.persistCashDiscountMode();
		});
	}

	handleTerminalAbort = async () => {
		if (this.terminalRequest && this.terminalRequest.cancel) {
			this.terminalRequest.cancel();
		}
		this.toggleLoading(false);
		let item = new API.BuildClass(Types.Terminals_Altrupay._name, API.RequestType.UPDATE);
		item.object.checkout = this.state.pkey
		item.object.pkey = this.state.terminal
		try {
			await item.submit(null, 'POST_ABORT');
		} finally {
			this.setState({loading: false});
		}
	}

	/**
	 * Invoice sidebar: taxable / non-taxable / subtotal / per-bucket rates / total tax.
	 * @param {*} totals from recalculateTotals()
	 * @param {*} location checkout location
	 */
	renderInvoiceTaxSection = (totals, location) => {
		const locationRate = newCheckoutLocationCombinedRate(location);
		const summary = totals.tax_summary;
		const hasBuckets = Array.isArray(summary) && summary.length > 0;
		const defaultBuckets = hasBuckets
			? summary.filter((row) => Math.abs(Number(row.rate) - locationRate) <= 0.0001)
			: [];
		const customBuckets = hasBuckets
			? summary.filter((row) => Math.abs(Number(row.rate) - locationRate) > 0.0001)
			: [];
		const displayBuckets = [];
		const defaultAmount = defaultBuckets.reduce((s, row) => s + Number(row.amount || 0), 0);
		const defaultTax = Math.round(defaultBuckets.reduce((s, row) => s + Number(row.tax || 0), 0) * 100) / 100;
		if (defaultAmount > 0 || (customBuckets.length === 0 && totals.tax_amount > 0)) {
			displayBuckets.push({
				group: 'Default',
				rate: locationRate,
				amount: defaultAmount > 0 ? defaultAmount : Number(totals.sub_total_tax || 0),
				tax: defaultAmount > 0 ? defaultTax : Number(totals.tax_amount || 0),
			});
		}
		displayBuckets.push(...customBuckets);
		const receiptRowStyle = {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'baseline',
			gap: '10px',
			fontSize: '0.95em',
			lineHeight: 1.45,
			padding: '2px 0',
		};

		return (
			<>
				<li>Taxable Total: $ {parseFloat(totals.sub_total_tax).toFixed(2)}</li>
				<li>Non-Taxable Total: $ {parseFloat(totals.sub_total_nontax).toFixed(2)}</li>
				{totals.tradein_total !== 0 &&
					<li>Trade-In Total: <span style={{color: "red"}}>$ {parseFloat(totals.tradein_total).toFixed(2)}</span></li>
				}
				{totals.membership_discount_amount > 0 &&
					<li>Membership Discount: <span style={{color: "red"}}>$ {parseFloat(totals.membership_discount_amount).toFixed(2)}</span></li>
				}
				<li>Sub Total: $ {totals.subtotal}</li>
				{displayBuckets.map((row, idx) => (
					<li key={`tax-${idx}-${row.group}-${row.rate}`} style={{ listStyle: 'none', marginLeft: 0 }}>
						<div style={receiptRowStyle}>
							<span>
								Tax: ${Number(row.amount).toFixed(2)} @ {Number(row.rate).toFixed(3)}%
								{row.group && row.group !== 'Default' && row.group !== 'FFLBoss' && row.group !== 'Consignments'
									? ` (${row.group})`
									: row.group === 'FFLBoss' &&
									  Math.abs(Number(row.rate) - locationRate) > 0.0001
										? ' (FFL)'
										: row.group === 'Consignments'
											? ' (Consignment)'
											: ''}
							</span>
							<span style={{ whiteSpace: 'nowrap' }}>$ {Number(row.tax).toFixed(2)}</span>
						</div>
					</li>
				))}
				{displayBuckets.length === 0 && totals.tax_amount > 0 && (
					<li style={{ listStyle: 'none', marginLeft: 0 }}>
						<div style={receiptRowStyle}>
							<span>Tax: ${parseFloat(totals.sub_total_tax).toFixed(2)} @ {Number(totals.tax_rate).toFixed(3)}%</span>
							<span style={{ whiteSpace: 'nowrap' }}>$ {totals.tax_amount.toFixed(2)}</span>
						</div>
					</li>
				)}
				{hasBuckets && displayBuckets.length > 1 && (
					<li style={{ marginTop: '4px', fontWeight: 600, listStyle: 'none', marginLeft: 0 }}>
						<div style={receiptRowStyle}>
							<span>Total tax:</span>
							<span style={{ whiteSpace: 'nowrap' }}>$ {totals.tax_amount.toFixed(2)}</span>
						</div>
					</li>
				)}
				{displayBuckets.length === 0 && totals.tax_amount <= 0 && (
					<li style={{ listStyle: 'none', marginLeft: 0 }}>
						<div style={receiptRowStyle}>
							<span>Tax:</span>
							<span style={{ whiteSpace: 'nowrap' }}>$ 0.00</span>
						</div>
					</li>
				)}
				{/*{hasCustomRate && (*/}
				{/*	<li style={{ fontSize: '0.82em', opacity: 0.85, listStyle: 'none', marginTop: '4px', marginLeft: 0 }}>*/}
				{/*		Location default combined rate: {Number(locationRate).toFixed(3)}% (state + county + city + special)*/}
				{/*	</li>*/}
				{/*)}*/}
			</>
		);
	};

	/**
	 * Canonical "checkout totals" order of operations — single source of truth for how discounts, trade-ins, and
	 * tax are layered together. Mirrored on the backend by `\Abstracts\Utilities::buildSectionFromLines` (see the
	 * PHP block comment there). When this method changes, update the PHP comment AND the matching logic in
	 * `buildSectionFromLines` so reports and receipts stay consistent with the cart.
	 *
	 *  1. Per line: cash discount when `cash_discounting && cash_discount_percentage` and a selected payment type
	 *     is in `cash_discount_payment_types`. Discounted
	 *     unit price = `round(cost / (1 + pct/100), 2)`. Accumulate `cash_discount_amount = (cost - discounted) * qty`.
	 *  2. Per line: subtract the line's `discount_amount` plus the first matching membership inventory group
	 *     discount from the line total (line-scope, not unit-scope). Membership discount list order is priority
	 *     order, and membership discounts do not stack.
	 *  3. Bucket each line:
	 *       - Items: rate from `sku_class.tax_override` when `should_override` else `combinedRate`; group =
	 *         `sku_class.name` or 'Default'.
	 *       - Consignments: rate = `combinedRate`; group = 'Consignments'.
	 *       - Products: rate = `tax_rate_fflboss` when account is FFL-linked and that rate is greater than 0;
	 *         otherwise `combinedRate`; group = 'FFLBoss'.
	 *     Non-taxable lines push into `nonTaxPool`; taxable lines push into `taxableLines[]`.
	 *  4. Sum trade-ins into `tradein_total` (deferred to step 8).
	 *  5. Sum layaway payments into `layaway_total` (added to subtotal at the very end; never affects tax).
	 *  6. Transaction-level discount — only ONE branch fires:
	 *       6a. `discount_percentage > 0`: scale `taxableLines[*].base *= (1 - pct/100)` AND `nonTaxPool *= (1 - pct/100)`.
	 *       6b. else if `discount_amount > 0`: subtract from the taxable sum first.
	 *           - If `taxSum > 0` and `taxSum - discount_amt < 0`: zero all taxable bases AND push the negative
	 *             remainder into `nonTaxPool`.
	 *           - Else if `taxSum > 0`: scale taxable lines by `factor = (taxSum - discount_amt) / taxSum`.
	 *           - Else (no taxable): subtract the full `discount_amt` from `nonTaxPool`.
	 *  7. Capture `global_discount_amount_applied` for display.
	 *  8. Apply trade-ins AFTER the global discount: subtract `tradein_total` from the new taxable sum by scaling
	 *     taxable lines proportionally; if `taxSum <= 0`, subtract from `nonTaxPool` instead.
	 *  9. `tax_total_raw = sum(line.base * line.rate / 100)`.
	 * 10. `tax_amount = ceil(tax_total_raw * 100) / 100`, clamped to `>= 0`. Whole-transaction ceiling, not per-bucket.
	 * 11. Aggregate buckets by `(group, rate)`: `amount = sum(base)`, `quantity = sum(qty)`, `tax = round(line_tax_raw * 100) / 100`.
	 *     The last bucket absorbs the +/-$0.01 difference between `sum(bucket.tax)` and the ceilinged `tax_amount`.
	 * 12. `subtotal = sub_total_tax + sub_total_nontax + (layaway_total if > 0)`.
	 * 13. `amount = subtotal + tax_amount + (card_fee if card payment and a location CC fee applies)`.
	 *
	 * @returns {{ amount: number, subtotal: number, tax_amount: number, sub_total_tax: number, sub_total_nontax: number, tax_buckets: Array, cash_discount_amount: number, membership_discount_amount: number, tradein_total: number, layaway_total: number, global_discount_amount_applied: number, remaining: number }}
	 */
	recalculateTotals = (stateOverride = null) => {

		const object = stateOverride || this.state;
		const root = this.props.rootState;
		const location = object.locations;
		const fflLinked = !!root.ffl_boss_linked;
		const combinedRate = newCheckoutLocationCombinedRate(location);

		let tradein_total = 0;
		let layaway_total = 0;
		let work_order_total = 0;
		let cash_discount_amount = 0;
		let membership_discount_amount = 0;
		const membershipDiscounts = membershipDiscountsInPriorityOrder(object.membership_inventory_group_discounts);

		const shouldCashDiscount = shouldApplyCashDiscount(root, object);

		/** @type {{ base: number, quantity: number, rate: number, group: string }[]} */
		const taxableLines = [];
		let nonTaxPool = 0;

		(object.items || []).forEach(item => {
			const quantity = item.quantity ?? 1;
			let unitCost = parseFloat(item.cost || 0);
			const discount = newCheckoutMoney(item.discount_amount);

			if (shouldCashDiscount) {
				const { discount_amount, discounted_unit_price } =
					cashDiscount(root.cash_discount_percentage, quantity, unitCost);

				unitCost = discounted_unit_price;
				cash_discount_amount += parseFloat(discount_amount);
			}

			const membershipDiscount = newCheckoutMembershipDiscountForItem(
				item,
				unitCost,
				quantity,
				discount,
				membershipDiscounts
			);
			membership_discount_amount += membershipDiscount;

			const lineTotal = (unitCost * quantity) - discount - membershipDiscount;

			if (item.taxable) {
				taxableLines.push({
					base: lineTotal,
					quantity,
					rate: newCheckoutEffectiveRateForItem(item, location),
					group: newCheckoutItemTaxGroupName(item),
				});
			} else {
				nonTaxPool += lineTotal;
			}
		});

		(object.consignments || []).forEach(consignment => {
			let unitCost = parseFloat(consignment.cost || 0);
			let quantity = parseFloat(consignment.quantity || 1);
			let discount = parseFloat(consignment.discount_amount || 0);

			if (shouldCashDiscount) {
				const { discount_amount, discounted_unit_price } =
					cashDiscount(root.cash_discount_percentage, quantity, unitCost);

				unitCost = discounted_unit_price;
				cash_discount_amount += parseFloat(discount_amount);
			}

			const lineTotal = (unitCost * quantity) - discount;

			if (consignment.taxable) {
				taxableLines.push({
					base: lineTotal,
					quantity,
					rate: combinedRate,
					group: 'Consignments',
				});
			} else {
				nonTaxPool += lineTotal;
			}
		});

		(object.products || []).forEach(product => {
			let cost = parseFloat(product.cost || 0);
			let discount = parseFloat(product.discount_amount || 0);

			if (shouldCashDiscount) {
				const { discount_amount, discounted_unit_price } =
					cashDiscount(root.cash_discount_percentage, 1, cost);

				cost = discounted_unit_price;
				cash_discount_amount += parseFloat(discount_amount);
			}

			const lineTotal = cost - discount;

			if (catalogTaxable(product.taxable, true)) {
				taxableLines.push({
					base: lineTotal,
					quantity: 1,
					rate: newCheckoutEffectiveRateForProduct(location, fflLinked),
					group: 'FFLBoss',
				});
			} else {
				nonTaxPool += lineTotal;
			}
		});

		// Services: location rate, fixed tax group; billable qty but no stock.
		(object.services || []).forEach((serviceLine) => {
			const quantity = serviceLine.quantity ?? 1;
			let unitCost = parseFloat(serviceLine.cost || 0);
			let discount = parseFloat(serviceLine.discount_amount || 0);

			if (shouldCashDiscount) {
				const {discount_amount, discounted_unit_price} =
					cashDiscount(root.cash_discount_percentage, quantity, unitCost);
				unitCost = discounted_unit_price;
				cash_discount_amount += parseFloat(discount_amount);
			}

			const lineTotal = unitCost * quantity - discount;

			if (serviceLine.taxable) {
				taxableLines.push({
					base: lineTotal,
					quantity,
					rate: combinedRate,
					group: "Services",
				});
			} else {
				nonTaxPool += lineTotal;
			}
		});

		(object.trades || []).forEach(trade => {
			tradein_total +=
				parseFloat(trade.quantity) *
				parseFloat(trade.trades.price);
		});

		(object.layaways || []).forEach(layaway => {
			layaway_total += parseFloat(layaway.total) ?? 0;
		});
		(object.work_orders || []).forEach(work_order => {
			work_order_total += parseFloat(work_order.total) ?? 0;
		});

		const discount_amt = parseFloat(object.discount_amount || 0);
		const discount_percent = parseFloat(object.discount_percentage || 0) / 100;

		let sub_total_tax_pre = taxableLines.reduce((s, l) => s + l.base, 0);
		let sub_total_nontax_pre = nonTaxPool;
		const before_global_total = sub_total_tax_pre + sub_total_nontax_pre;

		let global_discount_amount_applied = 0;

		if (discount_percent !== 0) {
			taxableLines.forEach(l => {
				l.base *= (1 - discount_percent);
			});
			nonTaxPool *= (1 - discount_percent);
			sub_total_tax_pre = taxableLines.reduce((s, l) => s + l.base, 0);
			sub_total_nontax_pre = nonTaxPool;
			global_discount_amount_applied = before_global_total - (sub_total_tax_pre + sub_total_nontax_pre);
		} else if (discount_amt !== 0) {
			let taxSum = taxableLines.reduce((s, l) => s + l.base, 0);
			if (taxSum > 0) {
				const newTax = taxSum - discount_amt;
				if (newTax < 0) {
					nonTaxPool += newTax;
					taxableLines.forEach(l => {
						l.base = 0;
					});
				} else {
					const factor = newTax / taxSum;
					taxableLines.forEach(l => {
						l.base *= factor;
					});
				}
			} else {
				nonTaxPool -= discount_amt;
			}
			sub_total_tax_pre = taxableLines.reduce((s, l) => s + l.base, 0);
			sub_total_nontax_pre = nonTaxPool;
			global_discount_amount_applied = before_global_total - (sub_total_tax_pre + sub_total_nontax_pre);
		}

		if (tradein_total !== 0) {
			const taxSum = taxableLines.reduce((s, l) => s + l.base, 0);
			if (taxSum > 0) {
				const factor = (taxSum - tradein_total) / taxSum;
				taxableLines.forEach(l => {
					l.base *= factor;
				});
			} else {
				nonTaxPool -= tradein_total;
			}
		}

		const sub_total_tax = taxableLines.reduce((s, l) => s + l.base, 0);
		const sub_total_nontax = nonTaxPool;

		let subtotal = sub_total_tax + sub_total_nontax;

		if (layaway_total > 0) {
			subtotal += layaway_total;
		}
		if (work_order_total > 0) {
			subtotal += work_order_total;
		}

		let tax_total_raw = 0;
		taxableLines.forEach(l => {
			tax_total_raw += l.base * (l.rate / 100);
		});
		let tax_amount = Math.ceil((tax_total_raw * 100).toFixed(3)) / 100;
		if (tax_amount < 0) tax_amount = 0;

		const tax_summary_map = {};
		taxableLines.forEach(l => {
			const amt = Math.max(0, l.base);
			if (amt > 0) {
				const lineTaxRaw = amt * (l.rate / 100);
				newCheckoutTaxSummaryAppend(tax_summary_map, l.group, l.rate, amt, l.quantity, lineTaxRaw);
			}
		});
		let tax_summary = Object.values(tax_summary_map).map((row) => {
			const tax = Math.round(row.tax_raw * 100) / 100;
			return {
				group: row.group,
				rate: row.rate,
				amount: row.amount,
				quantity: row.quantity,
				tax,
			};
		});
		const sumBucketTax = tax_summary.reduce((s, r) => s + r.tax, 0);
		const diff = Math.round((tax_amount - sumBucketTax) * 100) / 100;
		if (diff !== 0 && tax_summary.length > 0) {
			const last = tax_summary[tax_summary.length - 1];
			last.tax = Math.round((last.tax + diff) * 100) / 100;
		}
		let tax_rate_display = combinedRate;
		if (taxableLines.length > 0) {
			const rates = taxableLines.map(l => l.rate);
			const single = rates.every(r => Math.abs(r - rates[0]) < 0.0001);
			tax_rate_display = single ? rates[0] : (sub_total_tax > 0 ? (tax_amount / sub_total_tax) * 100 : 0);
		}

		let amount = subtotal + tax_amount;
		const flags = this.ccFeeFlags();
		const feeResult = applyCheckoutCcFee(amount, object, flags);
		let card_fee = feeResult.card_fee;
		amount = feeResult.amount;

		let remaining = amount;

		const paymentFields = ['cash_amount', 'check_amount', 'zelle_amount', 'other_amount', 'invoice_amount', 'card_amount'];
		if (amount >= 0) {
			paymentFields.forEach((field) => {
				const paymentValue = checkoutPaymentFieldAmount(field, object[field]);
				if (paymentValue > TOLERANCE) {
					remaining -= paymentValue;
				}
			});
		} else {
			// Disbursement (e.g. trade-in buy): payout amounts are entered positive.
			paymentFields.forEach((field) => {
				if (field === 'invoice_amount') {
					return;
				}
				const paymentValue = checkoutPaymentFieldAmount(field, object[field]);
				if (paymentValue > TOLERANCE) {
					remaining += paymentValue;
				}
			});
		}

		remaining = parseFloat(remaining).toFixed(2);

		const cc_fee_amount = parseFloat(card_fee).toFixed(2);

		return {
			sub_total_tax,
			sub_total_nontax,
			subtotal: subtotal.toFixed(2),
			tax_amount,
			tradein_total,
			layaway_total,
			work_order_total,
			cash_discount_amount,
			membership_discount_amount,
			card_fee,
			cc_fee_amount,
			global_discount_amount_applied,
			amount: parseFloat(amount).toFixed(2),
			remaining,
			tax_rate: tax_rate_display,
			tax_summary,
		};
	};

	renderCustomerMembershipInline = () => {
		if (!this.state.customer) {
			return null;
		}

		if (this.state.customerMembershipsLoading) {
			return (
				<div className="checkout-membership-inline checkout-membership-inline-muted">
					<span className="checkout-membership-header">
						<i className="fa fa-id-card-o"/>
						Memberships
					</span>
					<span>Loading...</span>
				</div>
			);
		}

		const memberships = Array.isArray(this.state.customer_memberships) ? this.state.customer_memberships : [];
		if (!memberships.length) {
			return (
				<div className="checkout-membership-inline checkout-membership-inline-muted">
					<span className="checkout-membership-header">
						<i className="fa fa-id-card-o"/>
						Memberships
					</span>
					<span>No membership found</span>
				</div>
			);
		}

		return (
			<div className="checkout-membership-list">
				{memberships.map((membership) => {
					const status = newCheckoutMembershipStatus(membership);
					const active = status === "Active";
					const coveredMember = membershipRole(membership) === "covered";
					const freeMembership = parseFloat(membership.cost_per_month) === 0;
					const payingCustomerName = membership.paying_customer && membership.paying_customer.name
						? membership.paying_customer.name
						: (freeMembership ? "billing contact" : "paying member");
					const dateSummary = membershipDateSummary(membership, newCheckoutFormatMembershipDate);
					return (
						<div className="checkout-membership-entry" key={`checkout-membership-${membership.pkey}`}>
							<MembershipBillingAlert
								membership={membership}
								onCancelled={() => {
									this.loadCustomerMemberships(this.state.customer);
									this.loadCustomerMembershipDiscounts(this.state.customer);
								}}
							/>
							<Link
								className="checkout-membership-inline checkout-membership-link"
								to={`/memberships/${membership.pkey}`}
							>
								<div className="checkout-membership-header">
									<i className="fa fa-id-card-o"/>
									Memberships
								</div>
								<div className="checkout-membership-line">
									<span className="checkout-membership-tier">
										{membership.level_tier || membership.name || "Membership"}
										{coveredMember ?
											<small className="checkout-membership-role">
												{freeMembership
													? `Covered member · billing contact ${payingCustomerName} · no charge`
													: `Covered member · billed to ${payingCustomerName}`}
											</small>
											: null}
									</span>
									<span className={classNames("checkout-membership-status", {"checkout-membership-status-expired": !active})}>
										{status}
									</span>
									<span className="checkout-membership-end-date">
										{dateSummary}
									</span>
								</div>
							</Link>
						</div>
					);
				})}
			</div>
		);
	};


	render() {

		/** @type {Checkouts_Object} object */
		let object = this.state;
		let { properties } = this.model;

		// PURE — must NOT setState inside
		const totals = this.recalculateTotals();

		const shouldCashDiscount = shouldApplyCashDiscount(this.props.rootState, object);
		const membershipDiscounts = membershipDiscountsInPriorityOrder(object.membership_inventory_group_discounts);

		let items = [];
		let consignments = [];
		let services = [];
		let trades = [];
		let products = [];
		let layaways = [];
		let work_orders = [];

		if (object.items) {
			items = object.items.map((item, i) => {

				item.quantity = item.quantity ?? 1;

				let _discounted_unit_price = null;
				let _discount_amount = null;

				if (shouldCashDiscount) {
					const { discount_amount, discounted_unit_price } =
						cashDiscount(
							this.props.rootState.cash_discount_percentage,
							item.quantity,
							item.cost
						);

					_discounted_unit_price = discounted_unit_price;
					_discount_amount = discount_amount;
				}

				const membershipDiscount = newCheckoutMembershipDiscountForItem(
					item,
					_discounted_unit_price ?? item.cost,
					item.quantity,
					item.discount_amount,
					membershipDiscounts
				);

				let total = (
					(parseFloat((_discounted_unit_price ?? item.cost)) *
						parseFloat(item.quantity)) -
					newCheckoutMoney(item.discount_amount) -
					membershipDiscount
				).toFixed(2);

				return (
					<tr key={i + this.state.itemKey}>
						<td className="text-center" style={{padding: '6px', width: '100px'}}>
							<Button color="danger default" onClick={() => {
								!this.state.loading && this.setState({loading: true}, () => {
									this.removeItemFromCart(item.pkey, item.quantity)
								})
							}}
							        size={"sm"}><i
								className={"fa fa-trash"}/></Button>
						</td>
						{this.clickableTD(item, item.name, 'itemName' + item.pkey)}
						{this.clickableTD(item, item.serial, 'itemSerial' + item.pkey)}
						{this.clickableTD(item, item.sku, 'itemSku' + item.pkey)}
						{this.clickableTD(item, item.cost, 'itemCost' + item.pkey, null, null, _discounted_unit_price)}
						<td className="text-center" style={{padding: '5px', textAlignLast: "center"}}>
							{/*buttons visibility is set to hidden in first conditional*/}
							<div className="quantity-controller">
								{item.quantity === 1 ?
									<Button
										style={{visibility: "hidden"}}
										color=" btn-default default"
										onClick={() => {
											this.updateItemQuantity(item.pkey, item.inventory, (item.quantity - 1));
											const currentCount = this.props.rootState.get('session_items_count') || 0;
											this.props.rootState.set({ session_items_count: currentCount - 1 });
										}}
										size={"sm"}
									>
										<i className={"fa fa-caret-left"}/>
									</Button> :
									<Button
										color=" btn-default default"
										onClick={() => {
											this.updateItemQuantity(item.pkey, item.inventory, (item.quantity - 1));
											const currentCount = this.props.rootState.session_items_count || 0;
											this.props.rootState.set({ session_items_count: currentCount - 1 });
										}}
										size={"sm"}
									>
										<i className={"fa fa-caret-left"}/>
									</Button>
								}
								<TextField
									value={item.quantity}
									inventory={item.inventory}
									pkey={item.pkey}
									style={{ width: "25px", textAlign: "center" }}
									onChange={(e) => this.handleQuantityInputChange(e.target.value, item)}
									margin="none"
									fullWidth={false}
								/>
								<Button
									color=" btn-default default"
									onClick={() => {
										this.updateItemQuantity(item.pkey, item.inventory, (item.quantity + 1));
										const currentCount = this.props.rootState.session_items_count || 0;
										this.props.rootState.set({ session_items_count: currentCount + 1 });
									}}
									size={"sm"}
								>
									<i className={"fa fa-caret-right"}/>
								</Button>
							</div>
						</td>
						<td className="text-center" style={{width: '235px', textAlignLast: "center", padding: '5px'}}>
							{this.renderTaxableButtons('Items', item.pkey, item.taxable)}
						</td>
						<td className="text-center" style={{width: "50px"}}>
							<TextField
								value={item.discount_amount}
								inventory={item.inventory}
								pkey={item.pkey}
								style={{
									width: "50px",
									textAlign: "center"
								}}
								onChange={this.updateSingularDiscount(i, item.inventory, item.pkey, 'item')}
								margin="none"
								fullWidth={false}
							/>
						</td>
						<td className="text-right">
							$&nbsp;{total}
							{_discount_amount &&
								<i style={{ color: 'red', paddingLeft: 5 }}>
									({_discount_amount})
								</i>
							}
							{membershipDiscount > 0 &&
								<i title="Membership discount" style={{ color: 'red', paddingLeft: 5 }}>
									(Member ${membershipDiscount.toFixed(2)})
								</i>
							}
						</td>
					</tr>
				);
			});
		}


		if (object.consignments) {
			consignments = object.consignments.map((consignment, i) => {

				let _discounted_unit_price = null;
				let _discount_amount = null;

				if (shouldCashDiscount) {
					const { discount_amount, discounted_unit_price } =
						cashDiscount(
							this.props.rootState.cash_discount_percentage,
							consignment.quantity,
							consignment.cost
						);

					_discounted_unit_price = discounted_unit_price;
					_discount_amount = discount_amount;
				}

				let subtotal = (
					(parseFloat(_discounted_unit_price ?? consignment.cost) *
						parseFloat(consignment.quantity)) -
					parseFloat(consignment.discount_amount || 0)
				).toFixed(2);

				return (
					<tr key={i}>
						<td className="text-center" style={{padding: '6px', width: '40px'}}>
							<Button color="danger default" onClick={() => {
								!this.state.loading && this.setState({loading: true}, () => {
									this.removeConsignmentFromCart(consignment.pkey)
								})
							}}
							        size={"sm"}><i
								className={"fa fa-trash"}/></Button>
						</td>
						{this.clickableTD(null, <span>{consignment.name + " - "}<em><Link to={{
							pathname: "/consignments/" + consignment.consignments.pkey,
							inventoryProps: {parent: consignment.consignments.pkey}
						}}>Consignment</Link></em>
						</span>, 'consignmentName' + consignment.consignments.pkey, null, consignment)}
						{this.clickableTD(null, consignment.serial, 'consignmentSerial' + consignment.consignments.pkey, null, consignment)}
						{this.clickableTD(null, consignment.sku, 'consignmentSku' + consignment.consignments.pkey, null, consignment)}
						{this.clickableTD(null, consignment.cost, 'consignmentPrice' + consignment.consignments.pkey, null, consignment, _discounted_unit_price)}
						<td className="text-center"> -</td>
						<td className="text-center" style={{width: '235px', textAlignLast: "center", padding: '5px'}}>
							{this.renderTaxableButtons('Consignments', consignment.pkey, consignment.taxable)}
						</td>
						<td className="text-center" style={{padding: '5px'}}>
							<TextField
								value={consignment.discount_amount}
								inventory={consignment.consignments}
								pkey={consignment.pkey}
								style={{
									width: "50px",
									textAlign: "center"
								}}
								onChange={this.updateSingularDiscount(i, consignment.inventory, consignment.pkey, 'consignment')}
								margin="none"
								fullWidth={false}
							/>

						</td>
						<td className="text-right">
							$ {subtotal}
							{_discount_amount &&
								<i style={{ color: 'red', paddingLeft: 5 }}>
									({_discount_amount})
								</i>
							}
						</td>
					</tr>
				);
			});
		}


		if (object.services) {
			services = object.services.map((serviceLine, i) => {
				let _discounted_unit_price = null;
				let _discount_amount = null;

				if (shouldCashDiscount) {
					const {discount_amount, discounted_unit_price} = cashDiscount(
						this.props.rootState.cash_discount_percentage,
						serviceLine.quantity,
						serviceLine.cost
					);
					_discounted_unit_price = discounted_unit_price;
					_discount_amount = discount_amount;
				}

				const subtotal = (
					parseFloat(_discounted_unit_price ?? serviceLine.cost) * parseFloat(serviceLine.quantity || 1) -
					parseFloat(serviceLine.discount_amount || 0)
				).toFixed(2);

				return (
					<tr key={"svc-" + i}>
						<td className="text-center" style={{padding: "6px", width: "40px"}}>
							<Button
								color="danger default"
								size="sm"
								onClick={() => {
									!this.state.loading &&
										this.setState({loading: true}, () => {
											this.removeServiceFromCart(serviceLine.pkey, serviceLine.quantity);
										});
								}}
							>
								<i className="fa fa-trash" />
							</Button>
						</td>
						{this.clickableTD(null, <span>{serviceLine.name}</span>, "serviceName" + serviceLine.pkey, null, serviceLine)}
						{this.clickableTD(null, "", "serviceSerial" + serviceLine.pkey, null, serviceLine)}
						{this.clickableTD(null, "", "serviceSku" + serviceLine.pkey, null, serviceLine)}
						{this.clickableTD(null, serviceLine.cost, "servicePrice" + serviceLine.pkey, null, serviceLine, _discounted_unit_price)}
						<td className="text-center" style={{padding: "5px", textAlignLast: "center"}}>
							<div className="quantity-controller">
								{parseInt(serviceLine.quantity, 10) === 1 ? (
									<Button
										style={{visibility: "hidden"}}
										color=" btn-default default"
										size="sm"
									>
										<i className="fa fa-caret-left" />
									</Button>
								) : (
									<Button
										color=" btn-default default"
										onClick={() => {
											const qty = parseInt(serviceLine.quantity, 10) || 1;
											void this.updateServiceQuantity(serviceLine.pkey, qty - 1);
											const currentCount = this.props.rootState.session_items_count || 0;
											this.props.rootState.set({session_items_count: currentCount - 1});
										}}
										size="sm"
									>
										<i className="fa fa-caret-left" />
									</Button>
								)}
								<TextField
									value={serviceLine.quantity}
									style={{width: "25px", textAlign: "center"}}
									onChange={(e) => this.handleServiceQuantityInputChange(e.target.value, serviceLine)}
									margin="none"
									fullWidth={false}
								/>
								<Button
									color=" btn-default default"
									onClick={() => {
										const qty = parseInt(serviceLine.quantity, 10) || 1;
										void this.updateServiceQuantity(serviceLine.pkey, qty + 1);
										const currentCount = this.props.rootState.session_items_count || 0;
										this.props.rootState.set({session_items_count: currentCount + 1});
									}}
									size="sm"
								>
									<i className="fa fa-caret-right" />
								</Button>
							</div>
						</td>
						<td className="text-center" style={{width: "235px", textAlignLast: "center", padding: "5px"}}>
							{this.renderTaxableButtons("Services", serviceLine.pkey, serviceLine.taxable)}
						</td>
						<td className="text-center" style={{padding: "5px"}}>
							<TextField
								value={serviceLine.discount_amount}
								pkey={serviceLine.pkey}
								style={{width: "50px", textAlign: "center"}}
								onChange={this.updateSingularDiscount(i, null, serviceLine.pkey, "service")}
								margin="none"
							/>
						</td>
						<td className="text-right">
							$ {subtotal}
							{_discount_amount && (
								<i style={{color: "red", paddingLeft: 5}}>({_discount_amount})</i>
							)}
						</td>
					</tr>
				);
			});
		}

		if (object.trades) {
			trades = object.trades.map((trade, i) => {

				let total = (
					parseFloat(trade.quantity) *
					parseFloat(trade.trades.price)
				).toFixed(2);

				return (
					<tr key={'p' + i}>
						<td className="text-center" style={{padding: '6px', width: '40px'}}>
							<Button color="danger default" onClick={() => {
								!this.state.loading && this.setState({loading: true}, () => {
									//TODO: changed this for dev to function properly, was pkey, revert if messes up on live
									this.removeTradeFromCart(trade.pkey, trade.quantity)
								})
							}} size={"sm"}><i
								className={"fa fa-trash"}/></Button>
						</td>
						<td className="text-center">{trade.trades.name}</td>
						<td className="text-center"></td>
						<td className="text-center"></td>
						<td className="text-center">{trade.trades.price}</td>
						<td className="text-center">{trade.quantity}</td>
						{/*leaving 2 blank cause trades aren't taxable or discountable*/}
						<td className="text-center"></td>
						<td className="text-center"></td>
						<td className="text-right">
							<span style={{ color: "red" }}>${total}</span>
						</td>
					</tr>
				);
			});
		}


		if (object.products) {
			products = object.products.map((item, i) => {

				let _discounted_unit_price = null;
				let _discount_amount = null;

				if (shouldCashDiscount) {
					const { discount_amount, discounted_unit_price } =
						cashDiscount(
							this.props.rootState.cash_discount_percentage,
							1,
							item.cost
						);

					_discounted_unit_price = discounted_unit_price;
					_discount_amount = discount_amount;
				}

				item.cost = item.cost !== null && !isNaN(item.cost) ? item.cost : (0).toFixed(2)

				let total = (
					parseFloat((_discounted_unit_price ?? item.cost)) -
					(parseFloat(item.discount_amount) || 0)
				).toFixed(2);

				return (
					<tr key={'p' + i}>
						<td className="text-center" style={{padding: '6px', width: '40px'}}>
							<Button color="danger default" onClick={() => {
								!this.state.loading && this.setState({loading: true}, () => {
									//TODO: changed this for dev to function properly, was pkey, revert if messes up on live
									this.removeProductFromCart(item.checkout)
								})
							}} size={"sm"}><i
								className={"fa fa-trash"}/></Button>
						</td>
						{this.clickableTD(null, item.name, 'productName' + item.checkout, item)}
						{this.clickableTD(null, <a href={"https://app.fflboss.com/products/" + item?._id}
						                           target="_blank">{item?.serial}</a>, 'productSerial' + item.checkout, item)}
						{this.clickableTD(null, item.sku, 'productSku' + item.checkout, item)}
						{this.clickableTD(null, item.cost, 'productPrice' + item.checkout, item, null, _discounted_unit_price)}
						<td className="text-center">1</td>
						<td className="text-center" style={{width: '235px', textAlignLast: "center", padding: '5px'}}>
							{this.renderTaxableButtons('Products', item.checkout, item.taxable)}
						</td>

						{/*Todo: get this working*/}
						<td className="text-center" style={{padding: '5px'}}>
							<TextField
								value={item.discount_amount}
								inventory={''}
								pkey={item.checkout}
								style={{
									width: "50px",
									textAlign: "center"
								}}
								onChange={this.updateSingularDiscount(i, item.inventory, item.checkout, 'product')}
								margin="none"
								fullWidth={false}
							/>
						</td>
						<td className="text-right">
							<span title={"Click on the Serial Number to update the price."}>
								$ {total}
								{_discount_amount &&
									<i style={{ color: 'red', paddingLeft: 5 }}>
										({_discount_amount})
									</i>
								}
							</span>
						</td>
					</tr>
				);
			});
		}

		if (object.layaways) {
			layaways = object.layaways.map((item, i) => {
				item.total =
					item.total != null && !isNaN(item.total)
						? item.total
						: (0).toFixed(2);

				object.layaway = true;
				object.layawayPkey = item.layaway;
				object.layawayMax = parseFloat(item.sku).toFixed(2);

				return (
					<tr key={'con' + i}>
						<td className="text-center" style={{padding: '6px', width: '40px'}}>
							<Button color="danger" onClick={() => {
								!this.state.loading && this.setState({loading: true}, () => {
									void this.removeLayawayFromCart(item.checkout)
								})
							}} size={"sm"}><i
								className={"fa fa-trash"}/></Button>
						</td>
						<td className="text-center" style={{width: '235px'}}>
							Layaway Payment
						</td>
						<td className="text-center">{item.serial}</td>
						<td className="text-center">{item.sku}</td>
						<td className="text-center">N/A</td>
						<td className="text-center">N/A</td>
						<td className="text-center">N/A</td>
						<td className="text-center">N/A</td>

						<td className="text-right">
							<input type={'number'} min={0.00} max={object.layawayMax} style={{width: '100%'}} value={item.total == 0.00 ? "" : item.total} onChange={(e) => {
								let newLayaways = JSON.parse(JSON.stringify(this.state.layaways));
								if(e.currentTarget.value !== "" && parseFloat(e.currentTarget.value) > parseFloat(item.sku)) {
									newLayaways[i].total = object.layawayMax;
								} else {
									newLayaways[i].total = e.currentTarget.value;
								}
								this.setState({layaways: newLayaways})
							}}/>
						</td>
					</tr>
				);
			});
		}

		if (object.work_orders) {
			work_orders = object.work_orders.map((item, i) => {
				item.total =
					item.total != null && !isNaN(item.total)
						? item.total
						: (0).toFixed(2);

				object.work_order = true;
				object.workOrderPkey = item.work_order;
				object.workOrderMax = parseFloat(item.sku).toFixed(2);

				return (
					<tr key={'wo' + i}>
						<td className="text-center" style={{padding: '6px', width: '40px'}}>
							<Button color="danger" onClick={() => {
								!this.state.loading && this.setState({loading: true}, () => {
									void this.removeWorkOrderFromCart(item.checkout)
								})
							}} size={"sm"}><i
								className={"fa fa-trash"}/></Button>
						</td>
						<td className="text-center" style={{width: '235px'}}>
							Work Order Payment
						</td>
						<td className="text-center">{item.serial}</td>
						<td className="text-center">{item.sku}</td>
						<td className="text-center">N/A</td>
						<td className="text-center">N/A</td>
						<td className="text-center">N/A</td>
						<td className="text-center">N/A</td>

						<td className="text-right">
							<input type={'number'} min={0.00} max={object.workOrderMax} style={{width: '100%'}} value={item.total == 0.00 ? "" : item.total} onChange={(e) => {
								let newWorkOrders = JSON.parse(JSON.stringify(this.state.work_orders));
								if(e.currentTarget.value !== "" && parseFloat(e.currentTarget.value) > parseFloat(item.sku)) {
									newWorkOrders[i].total = object.workOrderMax;
								} else {
									newWorkOrders[i].total = e.currentTarget.value;
								}
								this.setState({work_orders: newWorkOrders})
							}}/>
						</td>
					</tr>
				);
			});
		}

		const isContractPaymentCheckout = layaways.length > 0 || work_orders.length > 0;
		const isContractPaymentMode = isContractPaymentCheckout || object.layaway || object.work_order;

		let terminals = [];
		if (object.terminal) {
			let terminal = Cookies.getJSON('terminal');
			if (terminal && object.terminal === '') {
				object.terminal = terminal;
			}

			terminals = object.terminals.map(function (terminal) {
				return terminal;
			});

			if (object.terminal === '' && object.terminals.length > 0) {
				object.terminal = object.terminals[0]
			}

			Cookies.set('terminal', terminal);
		}

		let paidFor = checkoutPaymentsBalanced(object, totals);
		const balanceDisplay = checkoutBalanceDisplay(totals, object);
		object.processor_amount = totals.remaining;
		const hasCheckoutItems = checkoutHasLines({
			items,
			products,
			consignments,
			services,
			trades: object.trades || [],
			layaways,
			work_orders,
		});

		if (hasCheckoutItems) {
			object.manual = true;
		}

		if (parseFloat(object.discount_percentage || 0) !== 0) {
			object.alignment = 'percent';
		}

		let exists = object.pkey && object.pkey;

		return (
			<div className={'container-fluid'}>
				<UniversalModal
					isDev={APPCONFIG.settings.isDev()}
					locations={this.props.locations}
					name={"Services"}
					object={Collections.CheckoutServicesPicker}
					history={this.props.history}
					showModal={this.state.modalServices}
					reportClose={this.reportClose('modalServices')}
					size={'lg'}
					objectProps={{
						onServiceAdded: () => this.loadServices(),
						existingServiceIds: (this.state.services || []).map((line) => line.service),
					}}
				/>
				<UniversalModal
					isDev={APPCONFIG.settings.isDev()}
					locations={this.props.locations}
					name={"Trade-In"}
					object={Objects.TradeIn}
					history={this.props.history}
					showModal={this.state.modalTradeIn}
					reportClose={this.reportClose('modalTradeIn')}
					size={'lg'}
					objectProps={{forCheckout: true, afterSave: async () => {
							this.setState({loading: true})
							this.state.modalTradeIn = false;
							this.reportClose('modalTradeIn');
							if(_.isEmpty(this.state.pkey)) {
								window.location.reload()
							} else {
								await this.loadTrades()
							}
							this.setState({loading: false, modalTradeIn: false})
					}}}
					project={'pos'}
				/>

				<Card>
					{/*Modal for changing items on the checkout page directly*/}
					<Modal
						isOpen={this.state.itemIsChanging}
						toggle={() => this.setState({itemIsChanging: false})}
						size={"sm"}
						backdrop={true}
						style={{opacity: 1}}
					>
						<ModalHeader toggle={() => this.setState({itemIsChanging: false})}>
							Update for: {this.state.itemToChange.name}
						</ModalHeader>
						<ModalBody>
							<div className={"row"}>
								<div className={"col-md"}>
									<div className="row">
										<div className="col-12 align-content-center">
											<div className={"form-group"}>
												<TextField
													value={this.state.itemToChange.name}
													id="name"
													label="Name"
													variant="outlined"
													onChange={this.handleItemUpdate}
												/>
											</div>
											<div className={"form-group"}>
												<TextField
													value={this.state.itemToChange.serial}
													id="serial"
													label="Serial Number"
													variant="outlined"
													onChange={this.handleItemUpdate}
												/>
											</div>
											<div className={"form-group"}>
												<TextField
													value={this.state.itemToChange.sku}
													id="sku"
													label="Sku"
													variant="outlined"
													onChange={this.handleItemUpdate}
												/>
											</div>
											<div className={"form-group"}>
												<TextField
													value={this.state.itemToChange.cost}
													id="cost"
													label="Cost"
													variant="outlined"
													onChange={this.handleItemUpdate}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</ModalBody>
						<ModalFooter style={{justifyContent: "space-between"}}>
							<Button type={"button"} class="btn btn-secondary" onClick={() => this.setState({itemIsChanging: false})}>Close</Button>
							<Button type={"button"} class="btn btn-primary" onClick={() => this.handleSavingRowModal()}>Save</Button>
						</ModalFooter>
					</Modal>

					<CardContent>
						<fieldset>
							<div className="row justify-content-end" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start' }}>
								{!isContractPaymentMode && !!this.props.rootState.quick_checkout_enabled && (
									<div className="checkout-toolbar-add-item" style={{ flex: '1 1 240px', minWidth: '200px', maxWidth: '40%', paddingRight: '12px' }}>
										<CheckoutAddItemSelect
											disabled={!this.state.loaded}
											rootState={this.props.rootState}
											existingServiceIds={(this.state.services || []).map((line) => line.service)}
											onItemAdded={this.handleCheckoutAddItemAdded}
										/>
									</div>
								)}
								{/*Commenting this out for now*/}
								{/*{layaways.length === 0 && <div className={"col-2"}>*/}
								{/*	<div>*/}
								{/*		<ButtonGroup style={{marginRight: '10px'}}>*/}
								{/*			<Button*/}
								{/*				id={'true'}*/}
								{/*				color="primary"*/}
								{/*				active={this.state.layaway === false}*/}
								{/*				outline={this.state.layaway !== false}*/}
								{/*				onClick={this.handleTransactionType}*/}
								{/*			>*/}
								{/*				Transaction*/}
								{/*			</Button>*/}
								{/*			<Button*/}
								{/*				id={'false'}*/}
								{/*				color="primary"*/}
								{/*				active={this.state.layaway === true}*/}
								{/*				outline={this.state.layaway !== true}*/}
								{/*				onClick={this.handleTransactionType}*/}
								{/*			>*/}
								{/*				Layaway*/}
								{/*			</Button>*/}
								{/*		</ButtonGroup>*/}
								{/*	</div>*/}
								{/*</div>}*/}
								<div className="col-5" style={{ flex: '1 1 auto', minWidth: '300px', maxWidth: '50%' }}>
									<div className="row justify-content-end" style={{ display: 'flex', flexWrap: 'wrap' }}>
										<div className="col-6" style={{ flex: '1 1 auto', minWidth: '150px', maxWidth: '50%' }}>
											{/*{this.state.showRegister === true &&*/}
											<Framework.Elements.Select
												shouldLoad={this.state.loaded}
												object={object.registers}
												value={object.register}
												error={object.register_error}
												model={Types.Registers._name}
												property={properties.register}
												label={'Registers'}
												update={this.handleSelectPropertyUpdate}
											/>
										</div>
										{/*// }*/}
										{(this.props.rootState.location_plan === 1 || this.props.rootState.location_plan === 3) &&
											<div className="col-6" style={{ flex: '1 1 auto', minWidth: '150px', maxWidth: '50%' }}>
												<Framework.Elements.Select
													shouldLoad={this.state.loaded}
													value={object.terminal}
													error={object.terminal_error}
													model={Types.Terminals._name}
													property={properties.terminal}
													label={'Terminal'}
													update={this.handleSelectPropertyUpdate}
													id={'id'}
													text={'description'}
													textHelper={'manufacturer&model'}
												/>
											</div>}
										{this.state.hasKiosks ?
										<div className="col-6" style={{ flex: '1 1 auto', minWidth: '150px', maxWidth: '50%' }}>
											<Framework.Elements.Select
												shouldLoad={this.state.loaded}
												value={this.state.sharedKiosk}
												error={this.state.shared_kiosk_error || ""}
												model={Types.Kiosks._name}
												property={getKioskSelectProperty()}
												label={'Share to Kiosk'}
												update={this.handleKioskShareUpdate}
												nullable={true}
												text={'name'}
												sort={'name'}
												order={'asc'}
												limit={null}
												filter={this.isKioskAvailableForSharing}
											/>
											{this.state.sharedKiosk ?
												<Button
													className="secondary-button"
													size="sm"
													style={{marginTop: "8px"}}
													onClick={this.stopKioskSharing}
												>
													Stop Sharing to Kiosk
												</Button>
												: null}
										</div>
										: null}
									</div>
								</div>
								{/*<div className="col-1" style={{ flex: '0 1 auto', minWidth: '100px' }}>*/}
								{/*	<Button*/}
								{/*		block*/}
								{/*		size="md"*/}
								{/*		color="primary"*/}
								{/*		style={{ marginTop: '2px', width: '100%', height: '33px' }}*/}
								{/*		onClick={() => this.setState({modalServices: true})}*/}
								{/*	>*/}
								{/*		Services*/}
								{/*	</Button>*/}
								{/*</div>*/}
								<div className="col-1" style={{ flex: '0 1 auto', minWidth: '100px' }}>
									{(this.props.rootState.account === 10 || this.props.rootState.account === 168) &&
										<Button className="tradeInButton primary-button" block={true} size="md" style={{ marginTop: '2px', width: '100%', height: '33px' }}
										        onClick={() => {
											        this.setState({modalTradeIn: true})
										        }}>Trade In</Button>}
								</div>
								<div className="col-1" style={{ flex: '0 1 auto', minWidth: '100px' }}>
									{hasCheckoutItems &&
										<Button block={true} size="md" className="secondary-button" style={{ marginTop: '2px', width: '100%', height: '33px' }}
										        onClick={this.pause}>Pause</Button>}
								</div>
							</div>
							<hr/>
							<div className="row">

								<div className="col">
									<table className="table table-bordered table-striped">
										<thead>
											<tr className="thead-dark">
												<th className="text-center"/>
												<th className="text-center">Product</th>
												{!isContractPaymentCheckout ? <>
														<th className="text-center">Serial Number</th>
														<th className="text-center">SKU</th>
														<th className="text-center">Unit Cost</th>
														<th className="text-center">Quantity</th>
														<th className="text-center">Taxable</th>
														<th width="50px" className="text-center">Discount</th>
													</> :
													<>
														<th className="text-center">Customer Name</th>
														<th className="text-center">Remaining</th>
														<th className="text-center">N/A</th>
														<th className="text-center">N/A</th>
														<th className="text-center">N/A</th>
														<th width="50px" className="text-center">N/A</th>
													</>}
												<th className="text-center">{!isContractPaymentCheckout ? 'Total' : 'Payment Amount'}</th>
											</tr>
										</thead>
										<tbody>
											{items}
											{consignments}
											{services}
											{products}
											{trades}
											{layaways}
											{work_orders}
										</tbody>
									</table>
									<div className="row">
										<div className="col-2"/>
										{object.manual_card && paidFor === false ?
											<div className="col-6">
												<h4 style={{textAlign: 'center'}}>Manual Credit Card Entry for
													$ <span
														id={"remaining"}>{!isNaN(totals.remaining) ? totals.remaining: '0.00'}</span>
												</h4>
												<div className="row checkoutCardRow">
													<div className="col-6 checkoutCardCol">
														<Cards
															number={object.credit_card_number}
															name={object.credit_card_name}
															expiry={this.state.card_expiry}
															cvc={object.credit_card_cvc}
															focused={object.focused}
														/>
													</div>
													<div className="col-6 checkoutCardTextFieldCol">
														<div className={"form-group"}>
															<Framework.Elements.TextField
																name={"credit_card_number"}
																label={"Card Number"}
																value={object.credit_card_number}
																error={object.credit_card_number_error}
																property={properties.credit_card_number}
																update={this.handleTextFieldPropertyUpdate}
															/>
														</div>
														<div className={"form-group"}>
															<Framework.Elements.TextField
																name={"credit_card_name"}
																label={"Card Holder Name"}
																property={properties.credit_card_name}
																value={object.credit_card_name}
																error={object.credit_card_name_error}
																update={this.handleTextFieldPropertyUpdate}
															/>
														</div>
														<div className="row thirdRowCreditCardTextFields">
															<div className="col creditCardExpiry">
																<div className={"form-group"}>
																	<Framework.Elements.Date
																		name={"credit_card_expiry"}
																		label={"Exp."}
																		format={"MM/YY"}
																		mask={"__/__"}
																		views={['month', 'year']}
																		// it's in a screwed up format because of the masking
																		value={object.credit_card_expiry ? moment(object.credit_card_expiry).format("MM/YY/DD") : null}
																		error={object.credit_card_expiry_error}
																		property={properties.credit_card_expiry}
																		update={this.handleDateChange}
																	/>
																</div>
															</div>
															<div className="col creditCardCvc">
																<div className={"form-group"}>
																	<Framework.Elements.TextField
																		name={"credit_card_cvc"}
																		label={"CVC"}
																		value={object.credit_card_cvc}
																		error={object.credit_card_cvc_error}
																		property={properties.credit_card_cvc}
																		update={this.handleTextFieldPropertyUpdate}
																	/>
																</div>
															</div>
															<div className="col creditCardProcessButton">
																<div className={"form-group"}>
																	<Button className="primary-button" size="md" block={true}
																	        onClick={() => this.checkout("POST_CARD")}>
																		Process
																	</Button>
																</div>
															</div>
														</div>
														<p style={{textAlign: 'center'}}>
															Click <strong>Process</strong> to run the credit card manually
															or
															click <strong>Charge Card</strong> to process the remaining
															balance
															on the Credit Card Terminal.
														</p>
													</div>
												</div>
											</div> :
											<div className="col-6"/>}
										<div className="col-4 invoice-sum text-right">
											<ul className="list-unstyled">

												{!isContractPaymentCheckout && object.manual ?
													<li>
														<div style={{
															height: 56,
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'flex-end',
														}}>
															<ToggleButtonGroup value={object.alignment}
															                   exclusive
															                   selected={true}
															                   onChange={this.handleAlignment}
															                   style={{
																                   marginRight: '10px',
																                   marginTop: '2px'
															                   }}>
																<ToggleButton value="amount"
																              selected={object.alignment === "amount"}
																              style={{
																	              padding: '16px 20px',
																	              height: 'auto',
																	              minWidth: 0,
																              }}>
																	<i className={"fa fa-usd"}/>
																</ToggleButton>
																<ToggleButton value="percent"
																              selected={object.alignment === "percent"}
																              style={{
																	              padding: '16px 18px',
																	              height: 'auto',
																	              minWidth: 0,
																              }}>
																	<i className={"fa fa-percent"}/>
																</ToggleButton>
															</ToggleButtonGroup>
															{object.alignment === "amount" ?
																<div style={{width: '86px'}}>
																	<Framework.Elements.DollarAmount
																		label={"Discount"}
																		property={properties.discount_amount}
																		value={object.discount_amount}
																		error={object.discount_amount_error}
																		update={this.handleTextFieldPropertyUpdate}
																		margin={"dense"}
																	/>
																</div> :
																<div style={{width: '86px'}}>
																	<Framework.Elements.TextField
																		label={"Discount"}
																		property={properties.discount_percentage}
																		value={object.discount_percentage}
																		error={object.discount_percentage_error}
																		update={this.handleTextFieldPropertyUpdate}
																		type={'string'}
																		placeholder={"0.00"}
																		InputProps={{
																			endAdornment: (
																				<InputAdornment position={"end"}> <i
																					className="fa fa-percent"/></InputAdornment>
																			)
																		}}
																	/>
																</div>}
														</div>
														<hr style={{
															width: '200px',
															display: 'inline-block',
															marginBottom: '5px',
														}}/>
													</li> : null}
												{!isContractPaymentCheckout && <>
													{(this.props.rootState.cash_discounting && this.props.rootState.cash_discount_percentage && totals.cash_discount_amount)? <li style={{color: 'red'}}>Cash Discount ({this.props.rootState.cash_discount_percentage}%): $ <span style={{color: 'red'}}>{totals.cash_discount_amount.toFixed(2)}</span></li> : null}
													{totals.global_discount_amount_applied ? <li style={{color: 'red'}}>{parseFloat(object.discount_amount || 0) ? "Flat" : "Percent"} Discount {parseFloat(object.discount_percentage || 0) ? `(${this.state.discount_percentage}%)` : null}: $ <span style={{color: 'red'}}>{parseFloat(totals.global_discount_amount_applied).toFixed(2)}</span></li> : null}
													{this.renderInvoiceTaxSection(totals, object.locations)}
													{parseFloat(totals.card_fee) > 0 &&
														<li>CC Fee ({checkoutCcFeePercent(object, this.ccFeeFlags()).toFixed(2)}%): $ <span>{parseFloat(totals.card_fee).toFixed(2)}</span></li>
													}
													<li><strong>Total:
														$ <span>{isNaN(totals.amount) ? "0.00" : parseFloat(totals.amount).toFixed(2)}</span>
													</strong>
													</li>
												</>}

												{isContractPaymentCheckout && parseFloat(totals.card_fee) > 0 &&
													<>
														<li>CC Fee ({checkoutCcFeePercent(object, this.ccFeeFlags()).toFixed(2)}%): $ <span>{parseFloat(totals.card_fee).toFixed(2)}</span></li>
														<li><strong>Total:
															$ <span>{isNaN(totals.amount) ? "0.00" : parseFloat(totals.amount).toFixed(2)}</span>
														</strong>
														</li>
													</>
												}

												{object.manual ?
													<section>
														{/* Payment Buttons Row */}

														<div className={'row'} id="payment-buttons">
															<div className='payment-buttons-wrapper'>
																<div className="cash-container" onClick={this.toggleCashField}>
																	<div className='payment-button'>
																		<div style={this.getPaymentIconStyle(this.state.showCashField)}
																		     className="payment-icon-container">
																			<i className="fa fa-money" aria-hidden='true'></i>
																		</div>
																		<div className="payment-label">Cash</div>
																	</div>
																</div>
																<div className="check-container" onClick={this.toggleCheckField}>
																	<div className='payment-button'>
																		<div style={this.getPaymentIconStyle(this.state.showCheckField)}
																		     className="payment-icon-container">
																			<i className="fa fa-university" aria-hidden='true'></i>
																		</div>
																		<div className="payment-label">Check</div>
																	</div>
																</div>
																{this.props.rootState.allow_zelle &&
																<div className="zelle-container" onClick={this.toggleZelleField}>
																	<div className='payment-button'>
																		<div style={this.getPaymentIconStyle(this.state.showZelleField)}
																		     className="payment-icon-container">
																			<i className="fa fa-exchange" aria-hidden='true'></i>
																		</div>
																		<div className="payment-label">Zelle</div>
																	</div>
																</div>}
																{!isContractPaymentMode &&
																<div className="invoice-container" onClick={this.toggleInvoiceField}>
																	<div className='payment-button'>
																		<div style={this.getPaymentIconStyle(this.state.showInvoiceField)}
																		     className="payment-icon-container">
																			<i className="fa fa-file-text-o" aria-hidden='true'></i>
																		</div>
																		<div className="payment-label">To Invoice</div>
																	</div>
																</div>}
																{!isContractPaymentMode &&
																<div className="gift-certificate-container" onClick={this.toggleGiftCertField}>
																	<div className='payment-button'>
																		<div style={this.getPaymentIconStyle(this.state.showGiftCertField)}
																		     className="payment-icon-container">
																			<i className="fa fa-gift" aria-hidden='true'></i>
																		</div>
																		<div className="payment-label">Gift Cert.</div>
																	</div>
																</div>}
																<div className="credit-card-container" onClick={this.toggleCreditCardButtons}>
																	<div className='payment-button'>
																		<div style={this.getPaymentIconStyle(this.state.showCreditCardButtons)}
																		     className="payment-icon-container">
																			<i className="fa fa-credit-card" aria-hidden='true'></i>
																		</div>
																		<div className="payment-label">Credit Card</div>
																	</div>
																</div>
																{this.props.rootState.allow_debit &&
																<div className="debit-card-container" onClick={this.toggleDebitCardButtons}>
																	<div className='payment-button'>
																		<div style={this.getPaymentIconStyle(this.state.showDebitCardButtons)}
																		     className="payment-icon-container">
																			<i className="fa fa-credit-card-alt" aria-hidden='true'></i>
																		</div>
																		<div className="payment-label">Debit Card</div>
																	</div>
																</div>}
															</div>
														</div>

														{/* Conditional Payment Fields */}
														{object.showCashField && (
															<div className={'row'}>
																<div className={'col-10 offset-md-2 order-md-2'}>
																	<div className={'form-group'}>
																		<Framework.Elements.DollarAmount
																			name={"cash_amount"}
																			value={object.cash_amount}
																			error={object.cash_amount_error}
																			label={"Cash"}
																			property={properties.cash_amount}
																			update={this.handleAmountChange}
																			handleFocus={this.handleAmountFocus}
																			margin={"dense"}
																		/>
																	</div>
																</div>
															</div>
														)}
														{object.showCheckField && (
															<div className={'row'}>
																<div className={'col-10 offset-md-2 order-md-2'}>
																	<div className={'form-group'}>
																		<Framework.Elements.DollarAmount
																			name={"check_amount"}
																			label={"Check"}
																			property={properties.check_amount}
																			value={object.check_amount}
																			error={object.check_amount_error}
																			update={this.handleTextFieldPropertyUpdate}
																			handleFocus={this.handleAmountFocus}
																			margin={"dense"}
																		/>
																	</div>
																</div>
															</div>
														)}
														{object.showZelleField && (
															<div className={'row'}>
																<div className={'col-10 offset-md-2 order-md-2'}>
																	<div className={'form-group'}>
																		<Framework.Elements.DollarAmount
																			name={"zelle_amount"}
																			label={"Zelle"}
																			property={properties.zelle_amount}
																			value={object.zelle_amount}
																			error={object.zelle_amount_error}
																			update={this.handleTextFieldPropertyUpdate}
																			handleFocus={this.handleAmountFocus}
																			margin={"dense"}
																		/>
																	</div>
																</div>
															</div>
														)}
														{!isContractPaymentMode && object.showInvoiceField && (
															<div className={'row'}>
																<div className={'col-10 offset-2 order-md-2'}>
																	<div className={'form-group'}>
																		<Framework.Elements.DollarAmount
																			name={"invoice_amount"}
																			label={this.state.sudo_card === "" ? "To Invoice" : "Card"}
																			property={properties.invoice_amount}
																			value={object.invoice_amount}
																			error={object.invoice_amount_error === "0.00" ? "" : object.invoice_amount_error}
																			update={this.handleInvoiceAmountChange}
																			handleFocus={this.handleAmountFocus}
																			margin={'dense'}
																		/>
																	</div>
																</div>
															</div>
														)}
														{this.state.showGiftCertField && this.state.gift_certificates.map((row, index) => (
															<div className="row giftCardRow align-items-center" key={index}>
																<div className="col-1 offset-2 d-flex justify-content-start align-items-center giftCardRemove">
																	{this.state.gift_certificates.length > 1 && (
																		<div className="form-group">
																			<Button size="sm" color="danger" onClick={() => this.removeGiftCertificateRow(index)}>x</Button>
																		</div>
																	)}
																</div>
																<div className="col-5 order-md-2 giftCardSelect">
																	<div className="form-group">
																		<Framework.Elements.Select
																			shouldLoad={this.state.showGiftCertField}
																			object={row.pkey ? {pkey: row.pkey, name: row.name, value: row.value} : null}
																			value={row.pkey}
																			error={row.error ?? ''}
																			model={Types.Certificates._name}
																			requestOverride={'GET_UNUSED'}
																			property={properties.certificate}
																			label={index === 0 ? 'Gift Certificates' : ''}
																			text={'name&value'}
																			nullable={true}
																			isSearchable={true}
																			limit={20}
																			update={(prop, value, linked, certObject) =>
																				this.handleGiftCertificateSelect(index, value, certObject)
																			}
																		/>
																	</div>
																</div>
																<div className="col-4 order-md-3 giftCardDollarAmount">
																	<div className="form-group">
																		<Framework.Elements.TextField
																			key={row.pkey}
																			name={`amount_${index}`}
																			label="Amount"
																			disabled={false}
																			value={row.amount}
																			error={row.error ?? ''}
																			property={{...properties.other_amount, ignore_validation: true}}
																			update={(prop, val) => this.handleGiftCertificateAmountChange(index, prop, val)}
																			margin="dense"
																		/>
																	</div>
																</div>
															</div>
														))}
														{object.showGiftCertField && (
															<div className='row giftCardAdd align-items-right'>
																<div className="col-3 offset-9 d-flex">
																	<div className="form-group w-100">
																		<Button className="giftCardAddButton w-100 w-md-auto primary-button" size="sm" style={{ marginLeft: '5px' }} onClick={this.addGiftCertificateRow}>Add Gift Cert</Button>
																	</div>
																</div>
															</div>
														)}
														{object.showCreditCardButtons && (this.props.rootState.location_plan === 1 || this.props.rootState.location_plan === 3) && hasCheckoutItems && (
															<div>
																<div className="cc-button-wrapper">
																	{showManualCcFeeButton(object, this.ccFeeFlags()) && (
																		<Button className="primary-button"
																			size="md"
																			onClick={() => this.setState(
																				{card_percentage: !this.state.card_percentage},
																				() => { void this.persistCcFeeForKiosk(); }
																			)}
																		>
																			{this.state.card_percentage ? "Remove CC Fee" : "Add CC Fee"}
																		</Button>
																	)}
																	{!this.props.rootState.altrupay_linked &&
																		<Button className="primary-button" size="md" onClick={this.toggleManualCard}>
																			{!object.manual_card ? "Manual Card Entry" : "Go Back"}
																		</Button>
																	}
																	{(!paidFor || (paidFor && isContractPaymentCheckout)) && (
																		<Button className="primary-button"
																			size="md"
																			onClick={() => this.checkout('POST_TERMINAL').then(() => {
																				this.setState(prev => ({
																					...prev,
																					object: {
																						...prev.object,
																						card_charge: true
																					}
																				}));
																			})}
																		>
																			Charge Card
																		</Button>
																	)}
																</div>
															</div>
														)}
														{object.showCreditCardButtons && this.props.rootState.location_plan === 2 && hasCheckoutItems && (
															<div>
																<div>
																	{showManualCcFeeButton(object, this.ccFeeFlags()) && (
																		<Button className="primary-button"
																			size="md"
																			style={{marginRight: '10px'}}
																			onClick={() => this.setState({
																				card_percentage: !this.state.card_percentage,
																				sudo_card: !this.state.sudo_card ? "card" : ""
																			}, () => { void this.persistCcFeeForKiosk(); })}
																		>
																			{this.state.card_percentage ? "Remove CC Fee" : "Add CC Fee"}
																		</Button>
																	)}
																</div>
															</div>
														)}
														{object.showCreditCardButtons && isContractPaymentMode && (
															<div className={'row'} style={{ marginTop: '15px' }}>
																<div className={'col-10 offset-2 order-md-2'}>
																	<div className={'form-group'}>
																		<Framework.Elements.DollarAmount
																			name={"card_amount"}
																			label={"To Charge Card"}
																			property={properties.card_amount}
																			value={object.card_amount}
																			error={object.card_amount_error}
																			update={this.handleTextFieldPropertyUpdate}
																			handleFocus={this.handleAmountFocus}
																			margin={'dense'}
																		/>
																	</div>
																</div>
															</div>
														)}
														{object.showDebitCardButtons && (this.props.rootState.location_plan === 1 || this.props.rootState.location_plan === 3) && hasCheckoutItems && (
															<div>
																<div className="cc-button-wrapper">
																	{showManualCcFeeButton(object, this.ccFeeFlags()) && (
																		<Button
																			size="md"
																			color="primary"
																			onClick={() => this.setState(
																				{card_percentage: !this.state.card_percentage},
																				() => { void this.persistCcFeeForKiosk(); }
																			)}
																		>
																			{this.state.card_percentage ? "Remove CC Fee" : "Add CC Fee"}
																		</Button>
																	)}
																	{!this.props.rootState.altrupay_linked &&
																		<Button size="md" color="primary" onClick={this.toggleManualCard}>
																			{!object.manual_card ? "Manual Card Entry" : "Go Back"}
																		</Button>
																	}
																	{(!paidFor || (paidFor && isContractPaymentCheckout)) && (
																		<Button
																			size="md"
																			className="primary-button"
																			onClick={() => this.checkout('POST_TERMINAL').then(() => {
																				this.setState(prev => ({
																					...prev,
																					object: {
																						...prev.object,
																						card_charge: true
																					}
																				}));
																			})}
																		>
																			Charge Card
																		</Button>
																	)}
																</div>
															</div>
														)}
														{object.showDebitCardButtons && this.props.rootState.location_plan === 2 && hasCheckoutItems && (
															<div>
																<div>
																	{showManualCcFeeButton(object, this.ccFeeFlags()) && (
																		<Button
																			size="md"
																			color="primary"
																			style={{marginRight: '10px'}}
																			onClick={() => this.setState(
																				{card_percentage: !this.state.card_percentage},
																				() => { void this.persistCcFeeForKiosk(); }
																			)}
																		>
																			{this.state.card_percentage ? "Remove CC Fee" : "Add CC Fee"}
																		</Button>
																	)}
																</div>
															</div>
														)}
														{object.showDebitCardButtons && isContractPaymentMode && (
															<div className={'row'} style={{ marginTop: '15px' }}>
																<div className={'col-10 offset-2 order-md-2'}>
																	<div className={'form-group'}>
																		<Framework.Elements.DollarAmount
																			name={"card_amount"}
																			label={"To Charge Debit"}
																			property={properties.card_amount}
																			value={object.card_amount}
																			error={object.card_amount_error}
																			update={this.handleTextFieldPropertyUpdate}
																			handleFocus={this.handleAmountFocus}
																			margin={'dense'}
																		/>
																	</div>
																</div>
															</div>
														)}
													</section> : null
												}
												<li>
													<hr style={{ width: '200px', display: 'inline-block', marginBottom: '5px' }}/>
												</li>
												<li>
													<strong>
														{balanceDisplay.label}: $<span id={"amount"}>{balanceDisplay.value}</span>
													</strong>
												</li>
												{paidFor && (!this.state.card_amount || this.state.card_amount <= 0 || !isContractPaymentMode) && hasCheckoutItems && (
													<div>
														<Button className="primary-button" size="md" onClick={() => this.checkout('POST_CASH')}>
															Complete
														</Button>
													</div>
												)}
											</ul>
										</div>
									</div>
								</div>
							</div>

							{exists ?
								<div>
									<Typography color="textSecondary" gutterBottom>
										Created by {this.state.creator_name ?? this.props.rootState.name} {moment(object.created.value).local().format("MM/DD/YYYY hh:mm A")}
										{object.modified.value ?
											"| Modified " + moment(object.modified.value).local().format("MM/DD/YYYY hh:mm A")
											: null}

									</Typography>
								</div> : null}

							<hr/>

							{!isContractPaymentMode &&
							<h4 style={{display: "flex", justifyContent: 'space-between'}}>
								<div style={{textAlign: 'left'}}>
									Optional Fields
									<Button className="primary-button" size="md" style={{marginLeft: '10px'}} onClick={this.toggleOtherFields}>{this.state.optionalFields ? "Hide" : "Show"}</Button>
								</div>
								<div style={{textAlign: 'center'}}>
									<CustomerComponent
										locations={this.props.locations}
										object={object}
										properties={properties}
										shouldLoad={this.state.loaded}
										history={this.props.history}
										onTextUpdate={this.handleTextFieldPropertyUpdate}
										onSelectUpdate={this.handleCustomerSelectUpdate}
										afterCustomerSave={this.afterCustomerSave}
										key={object.customers ? JSON.stringify(object.customers) : "customer_checkout"}
									/>
									{this.renderCustomerMembershipInline()}
								</div>
								<div style={{textAlign: 'right'}}>
									Apply To Entire Checkout &nbsp;
									<ButtonGroup
										style={{marginRight: '10px'}}
									>
										<Button
											className="primary-button-buttongroup"
											color='primary'
											id='true'
											active={this.state.type === true}
											outline={this.state.type !== false}
											onClick={this.handleTypeChange}

										>
											Taxable
										</Button>
										<Button
											id='false'
											className="primary-button-buttongroup"
											color='primary'
											active={this.state.type === false}
											outline={this.state.type !== true}
											onClick={this.handleTypeChange}
										>
											Non-Taxable
										</Button>
									</ButtonGroup>
								</div>
							</h4>}


							{this.state.showOtherFields === true ?
								<div>
									<div className="row">

										<div className="col-3">
											<Framework.Elements.TextField
												name={"description"}
												label={"Transaction Description"}
												property={properties.description}
												value={object.description}
												error={object.description_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="col-3">
											<Framework.Elements.TextField
												name={"order_po_number"}
												label={"PO Number"}
												property={properties.order_po_number}
												value={object.order_po_number}
												error={object.order_po_number_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="col-3">
											<Framework.Elements.TextField
												name={"client"}
												label={"Client"}
												property={properties.client}
												value={object.client}
												error={object.client_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="col-3">
											<Framework.Elements.TextField
												name={"receipt_email"}
												label={"Email Receipt To"}
												property={properties.receipt_email}
												value={object.receipt_email}
												error={object.receipt_email_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>

									</div>
									<div className="row" style={{marginTop: 15}}>

										<div className="col-6">
											<Framework.Elements.TextField
												name={"description"}
												multiline={6}
												label={"Notes"}
												property={properties.notes}
												value={object.notes}
												error={object.notes_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="col-3">
											<Framework.Elements.TextField
												name={"salesman"}
												label={"Salesman"}
												property={properties.salesman}
												value={object.salesman}
												error={object.salesman_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
								: null}


						</fieldset>
						<div className={classNames("loader", {'active': this.state.loading})}>
							{this.update === 'POST_TERMINAL' &&
								<div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
									<Button
										style={{marginBottom: "75px"}}
										id={'false'}
										color="danger"
										onClick={this.handleTerminalAbort}
									>
										Abort Terminal
									</Button>
								</div>
							}
							<ClipLoader color={"#4A4A4A"} loading={this.state.loading}/>
						</div>
					</CardContent>
				</Card>
			</div>
		)
	}
}

export default Framework.Components.withRootState(CheckoutObject);
